import { Legend } from '@progress/kendo-angular-charts';
import { catchError, filter, retry } from 'rxjs/operators';
import { forkJoin, of, Subscription } from 'rxjs';
import {
  Months,
  Active_Status,
  Mcb_Status,
  Valve_Status,
  Communication_Status,
  BillStatus,
  WalletBalanceStatus,
  Activation_Status,
  BillingTypeList,
  OnOffStatusList,
} from './../../shared/constants/enum';
import { Router } from '@angular/router';
import { Component, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { LoaderService } from '../../core/services/loader.service';
import { deleteFaqs, getFaqs } from '../../store/Faq/faq.actions';
import {
  delateFaqSuccess,
  deleteFaqFailure,
  getFaqFailure,
  getFaqSuccess,
} from '../../store/Faq/faq-selector';
import { SharedService } from '../../shared/shared.service';
import { ConfirmationModal, Faq } from '../../shared/modals/common';
import {
  batteryLevel,
  Roles,
  SweetAlertIcon,
} from '../../shared/constants/enum';
import { FaqService } from '../../core/services/faq.service';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { table_pageSize } from '../../shared/constants/templatesNames';
import { formatDate } from '@angular/common'; // <-- Import formatDate from common
import {
  BsDatepickerConfig,
  BsDaterangepickerDirective,
} from 'ngx-bootstrap/datepicker';
import { log } from 'util';
import { ReportsService } from '../../core/services/reports.service';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Validations } from '../../shared/constants/validations';
import { AnyARecord } from 'dns';
@Component({
  selector: 'app-rp-reports',
  templateUrl: './rp-reports.component.html',
  styleUrl: './rp-reports.component.scss',
  standalone: false,
})
export class RpReportsComponent {
  isFirstOpen: boolean = true;
  isopen: boolean = false;

  breadCrumbItems: Array<{}> | undefined;
  selectedProject: any = [];
  seletedUtilityProject: any[] = [];
  selectedSettlementProject: any = [];
  selectedUtility: any = ['all'];
  consumption_selectedUtility: any = ['all'];
  dailyconsumption_selectedUtility: any = ['all'];
  billwise_selectedUtility: any = ['all'];
  deviceCommunication_selectedUtility: any = ['all'];
  meterReading_selectedUtility: any = ['all'];
  billgeneration_selectedUtility: any = ['all'];
  walletHistory_selectedUtility: any = ['all'];
  selectedBatteryLevel: string = 'all';
  dateRangeScheduledBillingValidationMessage: any = '';
  dateRangeOnOffStatusValidationMessage: any = '';
  dateRangePrepaidMeterOffStatusValidationMessage: any = '';
  configData: any = [];
  public isChecked = false;
  isUtilityChecked = false;
  isBatteryChecked = false;
  batteryLevel = batteryLevel;
  batterLevelDup = batteryLevel;
  projectsList: any = [];
  utilitybyProjectsList: any[] = [];
  projectsDupList: any = [];
  utilityList: any = [];
  utilitylistDup: any = [];
  listOfRoles = Roles;
  walletHistoryUtilityList: any = [];
  role: any;
  activationDateRange: any = [];
  settlemetDateRange: any[] = [];
  selectedScheduledBillingDateRange: any = [];
  selectedOnOffStatusDateRange: any = [];
  selectedPrepaidMeterOffStatusDateRange: any = [];
  highConsumptionDateRange: any = [];
  selectedYearMonth: any;
  consumptionDateRange: any = [];
  dailyconsumptionDateRange: any = [];
  deviceCommunicationDateRange: any = [];
  meterReadingDateRange: any = [];
  billGenerationDateRange: any = [];
  walletBalanceDateRange: any = [];
  walletHistoryDateRange: any = [];
  billwiseDateRange: any = [];
  rangeList: any = [
    { id: 'Day Wise', name: 'Day Wise' },
    { id: 'Range Wise', name: 'Range Wise' },
  ];
  datePickerConfig: Partial<BsDatepickerConfig>;
  activationDatePickerConfig: Partial<BsDatepickerConfig>;
  adminDateRangePickerConfig: Partial<BsDatepickerConfig>;
  Wallet_datePickerConfig: Partial<BsDatepickerConfig>;
  walletHistoryDatePickerConfig: Partial<BsDatepickerConfig>;
  deviceCommunicationdatePickerConfig: Partial<BsDatepickerConfig>;
  billGenerationDatePickerConfig: Partial<BsDatepickerConfig>;
  meterReadingsReportDates: Partial<BsDatepickerConfig>;
  datePickerscheduledBilling: Partial<BsDatepickerConfig>;
  datePickeronoffStatus: Partial<BsDatepickerConfig>;
  datePickerPrepaidMeterOffStatus: Partial<BsDatepickerConfig>;
  // datePickerConfigwithYearSelection: Partial<BsDatepickerConfig>;
  datePickerConfigwithYearSelection: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'MM/YYYY', // Display only Month & Year
    minMode: 'year', // Start selection from year
    showWeekNumbers: false,
    isAnimated: true,
    containerClass: 'theme-dark-blue',
  };

  billingType: any;
  BillingTypeList = BillingTypeList;
  OnOffStatusList = OnOffStatusList;
  GatewayStatusList = [
    { id: 'all', name: 'All' },
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' },
  ];

  selectedScheduledBillingType: any = '';
  selectedOnOffStatus: any = '';
  selectedGatewayStatus: any = '';
  monthsList: any = [];
  dupMonthsList: any = [];
  monthsListWithAll = Months;
  dupMonthsListWithAll = Months;
  scheduledBillingmonthsList: any = [];
  dupScheduledBillingmonthsList: any = [];
  selectScheduleBillingMonth: any = '';
  projectId: string;
  flatnumbersList: any = [];
  flatnumbersListDup: any = [];
  consumersIdsList: any = [];
  walletBanlanceFalttemList: any[] = [];
  billwise_selectedFlatNumber: any = ['all'];
  selectActivationStatus: any = 'all';
  select_Status: any = 'all';
  selecteddeviceCommunicationMcb: any = 'all';
  selectedValve_Status: any = 'all';
  selectedValve_Status_MeterReadings: string = 'all';
  selectedBill_Status: string = 'all';
  selectedCommnunicationStatus: any = 'all';
  deviceCommunication_selectedFlatNumber: any = ['all'];
  meterReading_selectedFlatNumber: any = ['all'];
  billGeneration_selectedFlatNumber: any = ['all'];
  Consumption_selectedFlatNumber: any = ['all'];
  dailyConsumption_selectedFlatNumber: any = ['all'];
  wallet_selectedFlatNumber: any = ['all'];
  wallet_FlatNumber: any = ['all'];
  selected_Consumers: any = ['all'];
  selected_walletbalance: any = ['all'];
  selectedMonthsForWalletBalanceReport: any = ['all'];

  meterMapping_selectedUtility: any = ['all'];
  meterMappingvaliadationMessage: string = '';
  selecteMappingUtilityProject: any[] = [];
  MeterMappingProjectValidationMessage: string = '';
  selectedMonth: any;
  exportActivationStatusForm!: UntypedFormGroup;
  submittedActivationStatus: boolean = false;
  exportActivationStatusFormValidations =
    Validations.exportActivationStatusFormValidations;
  utilityValidationMessage: string = '';
  utilityConsumptionValidationMessage: string = '';
  selectActivationStatusValidationMessage: string = '';
  consumptionDateRangeValidationMessage: string = '';
  dailyutilityValidationMessage: String = '';
  dateRangeValidationMessage: string = '';
  DeviceCommunicationdateRangeValidationMessage: string = '';

  waleyHistorydateRangeValidationMessage: string = '';

  consymerWalletdateRangeValidationMessage: string = '';
  billgendateRangeValidationMessage: string = '';
  meterreadingdateRangeValidationMessage: string = '';
  dailydateRangeValidationMessage: string = '';
  consumption_selectedRange: string = '';
  dateRangeSettlementValidationMessage: string = '';

  flatNumberValidationMessage: string = '';
  walletreportFaltValiadtion: string = '';
  consumervaliadationMessage: string = '';
  monthValidationMessage: string = '';
  Active_Status = Active_Status;
  Activation_Status = Activation_Status;
  Mcb_Status = Mcb_Status;
  Valve_Status = Valve_Status;
  Communication_Status = Communication_Status;
  BillStatis = BillStatus;
  WalletBalance_Status = WalletBalanceStatus;
  ProjectsValidationMessage: string = '';
  ProjectValidationMessage: string = '';
  ProjectSettlmentValidationMessage: string = '';
  isDeviceCommunication: boolean = false;
  iswalletBalnceReport: boolean = false;
  iswalleHistoryReportOpen: boolean = false;
  billingtypevalidation: any = '';
  onOffStatusvalidation: any = '';
  gatewayStatusvalidation: any = '';
  validationscheduledBillingProject: any = '';
  validationONOFFStatusProject: any = '';
  validationPrepaidMeterOffStatusProject: any = '';
  validationGatewayStatusProject: any = '';
  walletStatus: boolean = false;
  isConsumptionOpen: boolean = false;
  consumptionlistFromdashboard: any = {};
  hidePreviouseMeteravailableBtn: boolean = false;
  ismeterDownloadignInprogress: boolean = false;
  isMeterDownloadedLinkAvailable: boolean = false;
  meterfileUrl: any;
  meterReports: any = [];
  userId: any = '';
  downloadMeterSetinterval: any;
  statusMeterReadingSetinterval: any;
  BatteryLevelutilityList: any;
  BatteryLevelutilityListDup: any = [];
  private defaultRangeMaxDate: Date | null = null;
  private activationMinDate: Date | null = null;
  private activationDefaultMaxDate: Date | null = null;
  private pickerVisibleMaxDate: Date | null = null;
  private disabledTodayDates: Date[] = [];
  private rangePickerSubs = new Map<BsDaterangepickerDirective, Subscription>();
  private rangeMaxDates: Record<string, Date | undefined> = {};
  private rangePickerPending = new WeakSet<BsDaterangepickerDirective>();
  private rangeConfigs: Record<string, Partial<BsDatepickerConfig>> = {};
  private autoPreselectRanges = new Set<string>();
  private useMaxDateRangeForAll = true;
  private projectStartDateById = new Map<any, Date>();

  walletHistory_Reports: any[] = []; // Stores filtered consumption reports
  walletHistory_ReportfileUrl: any = null; // Stores the report download link

  iswalletHistory_DownloadignInprogress: boolean = false; // Report generating flag
  iswalletHistory_DownloadedLinkAvailable: boolean = false; // Report available flag
  hidePreviousewalletHistory_availableBtn: boolean = false; // Controls button visibility

  /* onOff Status Start*/

  onOffStatus_Reports: any[] = []; // Stores filtered consumption reports
  onOffStatus_Reports_ReportfileUrl: any = null; // Stores the report download link

  isonOffStatus_Reports_DownloadignInprogress: boolean = false; // Report generating flag
  isonOffStatus_Reports_DownloadedLinkAvailable: boolean = false; // Report available flag
  hidePreviouseonOffStatus_Reports_availableBtn: boolean = false; // Controls button visibility

  /* ONOF end */

  /* Prepaid Meter Off Status Start*/

  prepaidMeterOffStatus_Reports: any[] = [];
  prepaidMeterOffStatus_Reports_ReportfileUrl: any = null;

  isPrepaidMeterOffStatus_Reports_DownloadignInprogress: boolean = false;
  isPrepaidMeterOffStatus_Reports_DownloadedLinkAvailable: boolean = false;
  hidePreviousePrepaidMeterOffStatus_Reports_availableBtn: boolean = false;
  prepaidMeterOffStatus_ProjectsList: any = [];
  prepaidMeterOffStatus_ProjectsDupList: any = [];
  selectedPrepaidMeterOffStatusProject: any = [];
  private readonly prepaidMeterOffStatusReportNames = [
    'PrepaidMeterOffStatus-Report',
    'PrepaidMeterOffStatusReport',
    'Prepaid Meter Off Status Report',
    'MeterOffRequest-Report',
    'MeterOffRequestReport',
  ];

  /* Prepaid Meter Off Status end */

  /* Gateway Status Start */

  gatewayStatus_Reports: any[] = [];
  gatewayStatus_Reports_ReportfileUrl: any = null;

  isGatewayStatus_Reports_DownloadignInprogress: boolean = false;
  isGatewayStatus_Reports_DownloadedLinkAvailable: boolean = false;
  hidePreviouseGatewayStatus_Reports_availableBtn: boolean = false;
  private readonly gatewayStatusReportNames = [
    'GatewayStatus-Report',
    'GatewayStatusReport',
    'Gateway Status Report',
  ];

  /* Gateway Status End */

  highConsumption_Reports: any[] = [];
  highConsumption_Reports_ReportfileUrl: any = null;
  isHighConsumption_Reports_DownloadignInprogress: boolean = false;
  isHighConsumption_Reports_DownloadedLinkAvailable: boolean = false;
  hidePreviouseHighConsumption_Reports_availableBtn: boolean = false;

  /* ScheduleBilling Status Start*/

  ScheduleBilling_Reports: any[] = []; // Stores filtered consumption reports
  ScheduleBilling_Reports_ReportfileUrl: any = null; // Stores the report download link

  isScheduleBilling_Reports_DownloadignInprogress: boolean = false; // Report generating flag
  isScheduleBilling_Reports_DownloadedLinkAvailable: boolean = false; // Report available flag
  hidePreviouseScheduleBilling_Reports_availableBtn: boolean = false; // Controls button visibility

  /* ScheduleBilling end */

  consumptionReports: any[] = []; // Stores filtered consumption reports
  consumptionReportfileUrl: any = null; // Stores the report download link

  isConsumptionDownloadignInprogress: boolean = false; // Report generating flag
  isConsumptionDownloadedLinkAvailable: boolean = false; // Report available flag
  hidePreviouseConsumptionavailableBtn: boolean = false; // Controls button visibility

  deviceCommunicationReports: any[] = []; // Stores device communication reports
  deviceCommunicationfileUrl: any = null; // Stores the report download link

  isDeviceCommunicationDownloadignInprogress: boolean = false; // Flag for report generation status
  isDeviceCommunicationDownloadedLinkAvailable: boolean = false; // Flag for report availability
  hidePreviouseDeviceCommunicationReportavailableBtn: boolean = false; // Controls visibility of the previous report button
  Billing_ProjectsList: any = [];
  selectedScheduledBillingProject: any = [];
  selectedOnOffStatusProject: any = [];
  selectedGatewayStatusProject: any = [];
  selectedHighConsumptionProject: any = [];
  highConsumptionProjectValidationMessage: string = '';
  highConsumptionDateRangeValidationMessage: string = '';
  @ViewChild('activationPicker') activationPicker?: BsDaterangepickerDirective;

  constructor(
    private router: Router,
    private store: Store,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private reportService: ReportsService,
    private faqService: FaqService,
  ) {
    this.breadCrumbItems = [{ label: `Reports` }];
    const currentUserString = localStorage.getItem('currentUser');
    let currentUserData = JSON.parse(currentUserString ?? '');
    this.role = currentUserData?.currentUserRoleDetails?.role;
    this.billingType = currentUserData?.project?.billingType;
    this.projectId = currentUserData?.project?.id;
    this.walletStatus = currentUserData?.project?.isWalletEnabled;
    this.userId = currentUserData?.currentUserRoleDetails?.userId;
    //this.initalDateconfigs();
    /*  let today = new Date();
     let sixMonthsAgo = new Date();
     if (this.projectId) {
      // const dateon = new Date(currentUserData?.project?.startDate);
       const dateon = new Date('2025-11-28T10:16:45.000Z');
       console.log('Project Start Date:', dateon);
       // Get last day of previous month
       const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
 
       // Get first day of the month 6 months before last month
       let tentativeStart = new Date(
         endOfLastMonth.getFullYear(),
         endOfLastMonth.getMonth() - 5,
         1
       );
       console.log('Tentative Start Date (6 months ago):', tentativeStart);
       // Use whichever is later: project start or 6 months ago
       sixMonthsAgo =
         dateon > tentativeStart
           ? new Date(dateon.getFullYear(), dateon.getMonth(), 1)
           : tentativeStart;
       console.log('Six Months Ago Date after Project Check:', sixMonthsAgo);
     } else {
       // No project ID, fallback to general 6 months ago logic
       const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
       sixMonthsAgo = new Date(
         endOfLastMonth.getFullYear(),
         endOfLastMonth.getMonth() - 5,
         1
       );
     } */
    let today = new Date();
    let startDate: Date;
    let sixMonthsAgo: Date;

    const lastSixMonthAgoExcludecurrentMonth = new Date(
      today.getFullYear(),
      today.getMonth() - 6,
      1,
    );
    if (this.projectId) {
      const projectStart = new Date(currentUserData?.project?.startDate);
      // const projectStart = new Date('2025-11-28T10:16:45.000Z');
      today = new Date(); // refresh today

      // --- Get "6 months ago" date ---
      sixMonthsAgo = new Date(
        today.getFullYear(),
        today.getMonth() - 6,
        today.getDate(),
      );

      // RULE 1: project start older than 6 months → use 6 months ago
      if (projectStart < sixMonthsAgo) {
        startDate = sixMonthsAgo;
      }
      // RULE 2: project start within last 6 months → use project start
      else {
        startDate = projectStart;
      }
    } else {
      // No project → always last 6 months
      today = new Date();
      startDate = new Date(
        today.getFullYear(),
        today.getMonth() - 6,
        today.getDate(),
      );
      sixMonthsAgo = startDate; // same value
    }

    const normalizedToday = this.stripTime(today);
    const normalizedProjectStart = currentUserData?.project?.startDate
      ? this.stripTime(new Date(currentUserData.project.startDate))
      : null;
    const normalizedBillingCollectionStart =
      this.getBillingAndCollectionMinDate(currentUserData?.project) ??
      normalizedProjectStart;

    // For device communication
    const yesterday = new Date(normalizedToday);
    yesterday.setDate(normalizedToday.getDate() - 1);
    const maxReportDate =
      this.role === this.listOfRoles.SUPERADMIN ||
      this.role === this.listOfRoles.SUPERUSER
        ? normalizedToday
        : yesterday;
    const pickerVisibleMaxDate = maxReportDate;
    const prepaidMaxDate = new Date(maxReportDate);
    prepaidMaxDate.setDate(prepaidMaxDate.getDate() + 15); // Use the same max date for prepaid meter off status
    const disabledTodayDates: Date[] = [];
    this.defaultRangeMaxDate = maxReportDate;
    this.pickerVisibleMaxDate = pickerVisibleMaxDate;
    this.disabledTodayDates = disabledTodayDates;

    console.log('Final Start Date:', startDate);
    console.log('Six Months Ago:', sixMonthsAgo);
    console.log('End Date:', today);

    // -------------------- APPLY TO DATE PICKER --------------------

    this.datePickerConfig = {
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: this.activationMinDate ?? startDate, // <-- Use project start date for admin
      maxDate: pickerVisibleMaxDate,
      datesDisabled: disabledTodayDates,
      maxDateRange: 31,
    };
    this.activationMinDate =
      normalizedProjectStart ?? this.stripTime(startDate);
    // For activation: default to project start date, limit 31 days from selected start
    this.activationDefaultMaxDate = normalizedToday;
    const activationMaxByRange = this.activationMinDate
      ? this.calculateActivationMaxDate(this.activationMinDate)
      : this.activationDefaultMaxDate;
    this.setRangeMaxDate(
      'activationDateRange',
      activationMaxByRange ?? undefined,
    );
    this.activationDatePickerConfig = {
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: this.activationMinDate,
      maxDate: normalizedToday,
      datesDisabled: this.disabledTodayDates,
      value: undefined,
      maxDateRange: 31,
    };
    this.rangeConfigs['activationDateRange'] = {
      ...this.activationDatePickerConfig,
    };
    this.adminDateRangePickerConfig = {
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: this.activationMinDate,
      maxDate: pickerVisibleMaxDate,
      datesDisabled: disabledTodayDates,
      maxDateRange: 31,
    };
    this.Wallet_datePickerConfig = {
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: this.activationMinDate ?? lastSixMonthAgoExcludecurrentMonth, // <-- Use project start for admin
      maxDate: normalizedToday,
      datesDisabled: disabledTodayDates,
      maxDateRange: 31,
    };
    this.walletHistoryDatePickerConfig = {
      ...this.Wallet_datePickerConfig,
      maxDate:
        this.role === this.listOfRoles.ADMIN ? normalizedToday : pickerVisibleMaxDate,
    };

    this.deviceCommunicationdatePickerConfig = {
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: this.activationMinDate ?? startDate, // <-- Use project start date for admin
      maxDate: normalizedToday,
      datesDisabled: disabledTodayDates,
      maxDateRange: 31,
    };
    this.billGenerationDatePickerConfig = {
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: normalizedBillingCollectionStart ?? this.activationMinDate,
      maxDate: normalizedToday,
      datesDisabled: disabledTodayDates,
      maxDateRange: 31,
    };

    this.datePickerscheduledBilling = Object.assign({
      // dateInputFormat: 'YYYY-MM-DD', // Customize as needed
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: new Date(2025, 4, 22), // Set minimum date to May 17, 2025.
      maxDate: yesterday,
      datesDisabled: [],
      maxDateRange: 31,
    });
    this.datePickeronoffStatus = Object.assign({
      // dateInputFormat: 'YYYY-MM-DD', // Customize as needed
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: new Date(2025, 4, 17), // Set minimum date to May 17, 2025. 0 = January,4 = May
      maxDate: pickerVisibleMaxDate,
      datesDisabled: disabledTodayDates,
      maxDateRange: 31,
    });
    const prepaidMeterOffStatusStartDate = this.addDays(normalizedToday, -15);
    this.datePickerPrepaidMeterOffStatus = Object.assign({
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: prepaidMeterOffStatusStartDate,
      maxDate: normalizedToday,
      datesDisabled: disabledTodayDates,
      maxDateRange: 15,
    });
    const meterReadingMaxDate = this.stripTime(new Date(normalizedToday));
    const meterReadingMinDate = new Date(
      meterReadingMaxDate.getFullYear(),
      meterReadingMaxDate.getMonth() - 6,
      1,
    );
    meterReadingMinDate.setDate(
      Math.min(
        meterReadingMaxDate.getDate(),
        new Date(
          meterReadingMinDate.getFullYear(),
          meterReadingMinDate.getMonth() + 1,
          0,
        ).getDate(),
      ),
    );
    const meterReadingVisibleMaxDate = meterReadingMaxDate;
    const meterReadingDisabledDates: Date[] = [];

    this.meterReadingsReportDates = Object.assign({
      dateInputFormat: 'YYYY-MM-DD',
      rangeInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      containerClass: 'theme-dark-blue',
      minDate: meterReadingMinDate,
      maxDate: meterReadingVisibleMaxDate,
      datesDisabled: meterReadingDisabledDates,
      maxDateRange: 31,
    });
    /*   if (this.projectId) {
      this.getAllFlatNumbers();
    } */

    if (
      history.state.consumptionItem != undefined &&
      history.state.consumptionItem !== null
    ) {
      this.consumptionlistFromdashboard = history.state.consumptionItem;
      this.isConsumptionOpen = true;
      console.log(this.consumptionlistFromdashboard);
    }

    this.getLastSixMonthsWithAll();
    this.getLastSixMonthsExcludingCurrent();
  }
 
  ngOnInit() {
    if (this.role == this.listOfRoles.ADMIN) {
      this.callConfigAndFlatNumbers();
      this.getLatestMeterReadingsReportStatus('initcheck');
      this.getLatestConsumptionReadingsReportStatus('initcheck');
      this.getLatestDeviceCommunicationReportStatus('initcheck');
      this.getLatestWalletHistoryReportStatus('initcheck');

      this.getConsumerByProject();
    } else {
      this.getLatestONOFFStatusReportStatus('initcheck');
      this.getLatestGatewayStatusReportStatus('initcheck');
      this.getLatestHighConsumptionReportStatus('initcheck');
      this.getLatestScheduleBillingReportStatus('initcheck');
      this.getLatestPrepaidMeterOffStatusReportStatus('initcheck');
      this.getAllConfigData();
      this.getPrepaidMeterOffStatusProjects();
      this.getutilityproject();
    }
    const currentDate = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
  }
    private filterReportUtilityList(utilities: any[] = []): any[] {
    return (utilities || []).filter((item: any) => {
      const utilityName = (item?.name ?? '').toString().trim().toLowerCase();
      return utilityName !== 'ev';
    });
  }
  callConfigAndFlatNumbers() {
    let payload = ['utilities', 'projects', 'statementMonths'];
    this.loaderService.setLoading(true);

    forkJoin({
      config: this.sharedService.getAllConfigData(payload),
      flats: this.reportService.getFlatNumbersByProjectId(this.projectId),
    }).subscribe({
      next: ({ config, flats }) => {
        //console.log(config);
        //  console.log(flats);
        // ✅ Handle config data
        if (config?.statusCode === 200) {
          this.configData = config.data;

          this.configData.utilities = [
            {
              id: 'all',
              name: 'All Utilities',
            },
            ...(config.data?.utilities || []), // Use an empty array if data.data.utilities is undefined
          ];

          this.configData.projects = [
            {
              id: 'all',
              name: 'All Projects',
            },
            ...(config.data?.projects || []),
          ];

          this.projectsDupList = [
            // {
            //   id: 'all',
            //   name: 'All Projects',
            // },
            ...this.configData?.projects,
          ];

          this.projectsList = [...this.configData?.projects];
           this.walletHistoryUtilityList = [...this.configData?.utilities];
          this.utilityList = this.filterReportUtilityList([
            ...this.configData?.utilities,
          ]);
         
           this.utilitylistDup = [...this.utilityList];

          this.BatteryLevelutilityList = this.configData?.utilities.filter(
            (item: any) =>
              item.name !== 'Electricity' &&
              item.name.toLowerCase() !== 'trisource' &&
              item.name.toLowerCase() !== 'ev',
          );
          this.BatteryLevelutilityListDup = [
            ...this.configData?.utilities.filter(
              (item: any) =>
                item.name !== 'Electricity' &&
                item.name.toLowerCase() !== 'trisource' &&
                item.name.toLowerCase() !== 'ev',
            ),
          ];

          const currentProject = (config.data?.projects || []).find(
            (project: any) =>
              project?.id === this.projectId ||
              project?.projectId === this.projectId,
          );
          this.setStatementMonthsList(config.data, currentProject);
          this.updateBillGenerationMinDate(currentProject);
        }

        // ✅ Handle flat numbers
        if (flats?.statusCode === 200) {
          const flatList = [{ id: 'all', flatNo: 'All Flats' }, ...flats.data];
          this.flatnumbersList = flatList;
          this.flatnumbersListDup = flatList;
          this.walletBanlanceFalttemList = flatList;
        }
        this.dashboradNavigationdetails();
        // this.loaderService.setLoading(false);
      },
      error: (err) => {
        console.error('Error in forkJoin:', err);
        this.loaderService.setLoading(false);
      },
    });
  }
  private updateWalletBalanceMinDate(startDate: string | Date | null) {
  if (!startDate) return;

  const minDate = this.stripTime(new Date(startDate));

  this.Wallet_datePickerConfig = {
    ...this.Wallet_datePickerConfig,
    minDate,
  };

  this.rangeConfigs['walletBalanceDateRange'] = {
    ...this.Wallet_datePickerConfig,
    minDate,
  };
}

  private updateBillGenerationMinDate(project: any) {
    const currentUserString = localStorage.getItem('currentUser');
    const currentUserData = currentUserString
      ? JSON.parse(currentUserString)
      : null;
    const fallbackProject = currentUserData?.project;
    const effectiveProject =
      project?.billingInitiatedOn ||
      project?.postpaidStartDate ||
      project?.projectStartDate?.startDate ||
      project?.startDate
        ? project
        : fallbackProject;

    const minDate = this.getBillingAndCollectionMinDate(effectiveProject);
    console.log('[BillingCollection] project date values:', {
      startDate: effectiveProject?.startDate,
      projectStartDate: effectiveProject?.projectStartDate?.startDate,
      billingInitiatedOn: effectiveProject?.billingInitiatedOn,
      postpaidStartDate: effectiveProject?.postpaidStartDate,
      computedMinDate: minDate,
    });
    if (!minDate) return;

    this.billGenerationDatePickerConfig = {
      ...this.billGenerationDatePickerConfig,
      minDate,
    };

    this.rangeConfigs['billGenerationDateRange'] = {
      ...this.billGenerationDatePickerConfig,
      minDate,
    };
    console.log(
      '[BillingCollection] applied date picker minDate:',
      this.billGenerationDatePickerConfig.minDate,
    );

    if (
      Array.isArray(this.billGenerationDateRange) &&
      this.billGenerationDateRange[0] &&
      this.stripTime(this.billGenerationDateRange[0]) < minDate
    ) {
      this.billGenerationDateRange = [];
    }
  }

  private getBillingAndCollectionMinDate(project: any): Date | null {
    const candidateDates = [
      project?.startDate,
      project?.projectStartDate?.startDate,
      project?.billingInitiatedOn,
      project?.postpaidStartDate,
    ];

    const rawStartDate = candidateDates.find(
      (date) =>
        !!date &&
        date !== '0001-01-01T00:00:00' &&
        date !== '0001-01-01',
    );

    if (!rawStartDate) {
      return null;
    }

    const parsedDate = new Date(rawStartDate);
    return isNaN(parsedDate.getTime()) ? null : this.stripTime(parsedDate);
  }

  private setStatementMonthsList(configData: any, project: any): void {
    const statementMonths =
      configData?.statementMonths ;


    const configuredMonths = this.normalizeStatementMonths(statementMonths);
    if (configuredMonths.length > 0) {
      this.monthsList = configuredMonths;
      this.dupMonthsList = [...configuredMonths];
      return;
    }

    const startDate =
      this.getStatementStartDate(statementMonths) ??
      this.parseProjectStartDate(project) ??
      this.parseProjectStartDate(this.getCurrentUserProject());
    const endDate =
      this.getStatementEndDate(statementMonths) ?? this.stripTime(new Date());

    if (!startDate) {
      this.monthsList = [];
      this.dupMonthsList = [];
      return;
    }

    const months = this.buildStatementMonthLabels(startDate, endDate);
    this.monthsList = months;
    this.dupMonthsList = [...months];
  }

  private normalizeStatementMonths(statementMonths: any): string[] {
    const source = Array.isArray(statementMonths)
      ? statementMonths
      : (statementMonths?.months ?? statementMonths?.statementMonths);

    if (!Array.isArray(source)) {
      return [];
    }

    const months = source
      .map((item: any) => this.getStatementMonthLabel(item))
      .filter((item: string | null): item is string => !!item);

    return this.sortStatementMonthLabels([...new Set(months)]);
  }

  private getStatementMonthLabel(item: any): string | null {
    if (!item) {
      return null;
    }

    if (typeof item === 'string') {
      const parsedDate = this.parseDateValue(item);
      return parsedDate ? this.formatStatementMonth(parsedDate) : item.trim();
    }

    const label =
      item?.name ??
      item?.label ??
      item?.monthYear ??
      item?.monthyear ??
      item?.monthName;
    if (label) {
      return String(label).trim();
    }

    if (item?.month && item?.year) {
      return `${item.month}-${item.year}`;
    }

    const date =
      this.parseDateValue(item?.date) ??
      this.parseDateValue(item?.startDate) ??
      this.parseDateValue(item?.fromDate);
    return date ? this.formatStatementMonth(date) : null;
  }

  private getStatementStartDate(statementMonths: any): Date | null {
    return (
      this.parseDateValue(statementMonths?.startDate) ??
      this.parseDateValue(statementMonths?.fromDate) ??
      this.parseDateValue(statementMonths?.projectStartDate?.startDate) ??
      this.parseDateValue(statementMonths?.projectStartDate) ??
      this.parseDateValue(statementMonths?.statementStartDate)
    );
  }

  private getStatementEndDate(statementMonths: any): Date | null {
    return (
      this.parseDateValue(statementMonths?.endDate) ??
      this.parseDateValue(statementMonths?.toDate) ??
      this.parseDateValue(statementMonths?.currentDate) ??
      this.parseDateValue(statementMonths?.statementEndDate)
    );
  }

  private buildStatementMonthLabels(startDate: Date, endDate: Date): string[] {
    const start = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    const months: string[] = [];

    for (
      let cursor = new Date(start);
      cursor <= end;
      cursor.setMonth(cursor.getMonth() + 1)
    ) {
      months.push(this.formatStatementMonth(cursor));
    }

    return months.reverse();
  }

  private formatStatementMonth(date: Date): string {
    const monthName = Months[date.getMonth()]?.name;
    return `${monthName}-${date.getFullYear()}`;
  }

  private sortStatementMonthLabels(months: string[]): string[] {
    return [...months].sort((first, second) => {
      const firstDate = this.parseStatementMonthLabel(first);
      const secondDate = this.parseStatementMonthLabel(second);

      if (!firstDate && !secondDate) {
        return 0;
      }
      if (!firstDate) {
        return 1;
      }
      if (!secondDate) {
        return -1;
      }

      return secondDate.getTime() - firstDate.getTime();
    });
  }

  private parseStatementMonthLabel(value: string): Date | null {
    const [monthName, year] = value.split('-').map((item) => item.trim());
    const monthIndex = Months.findIndex(
      (month: any) => month.name.toLowerCase() === monthName?.toLowerCase(),
    );
    const yearValue = Number(year);

    if (monthIndex === -1 || !Number.isFinite(yearValue)) {
      return null;
    }

    return new Date(yearValue, monthIndex, 1);
  }

  private parseDateValue(value: any): Date | null {
    if (!value) {
      return null;
    }

    const raw = typeof value === 'object' ? value?.startDate : value;
    if (!raw || raw === '0001-01-01T00:00:00' || raw === '0001-01-01') {
      return null;
    }

    const parsed = new Date(raw);
    return isNaN(parsed.getTime()) ? null : this.stripTime(parsed);
  }

  private getCurrentUserProject(): any {
    const currentUserString = localStorage.getItem('currentUser');
    return currentUserString ? JSON.parse(currentUserString)?.project : null;
  }

  exportOnOffSttausreport() {
    let isValid = true;
    this.validationONOFFStatusProject = '';
    this.onOffStatusvalidation = '';
    this.dateRangeOnOffStatusValidationMessage = '';

    if (!this.selectedOnOffStatus) {
      this.onOffStatusvalidation = 'Please select Status';
      isValid = false;
    }
    if (
      !this.selectedOnOffStatusProject ||
      this.selectedOnOffStatusProject.length === 0
    ) {
      this.validationONOFFStatusProject = 'Please select Projects';
      isValid = false;
    }

    if (
      !this.selectedOnOffStatusDateRange ||
      this.selectedOnOffStatusDateRange.length !== 2
    ) {
      this.dateRangeOnOffStatusValidationMessage =
        'Please select a date range.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      let fromDate: string | null = null;
      let toDate: string | null = null;

      const from = new Date(
        this.selectedOnOffStatusDateRange[0].getTime() -
          this.selectedOnOffStatusDateRange[0].getTimezoneOffset() * 60000,
      );
      const to = new Date(
        this.selectedOnOffStatusDateRange[1].getTime() -
          this.selectedOnOffStatusDateRange[1].getTimezoneOffset() * 60000,
      );
      fromDate = from.toISOString().slice(0, 10);
      toDate = to.toISOString().slice(0, 10);
      console.log(this.selectedOnOffStatusProject);
      const selectedProjects =
        this.selectedOnOffStatusProject[0] === 'all'
          ? this.projectsList
              .filter((data: any) => data.projectId && data.projectId !== 'all')
              .map((data: any) => data.projectId)
          : this.selectedOnOffStatusProject;

      const payload = {
        projectId: selectedProjects,
        status: this.selectedOnOffStatus,
        fromDate: fromDate,
        toDate: toDate,
        userId: this.userId,
      };
      console.log(payload);
      this.reportService
        .exportReportMeterReadings(payload, 'OnOffStatusReport')
        .subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.getLatestONOFFStatusReportStatus('download');
              // console.log(response.message); // "Report downloaded successfully."
            } else {
              //  console.log(response.message); // "No Data Found." or any other message
            }
          },
          error: (err) => {
            this.loaderService.setLoading(false);
            console.error('Error while exporting report:', err);
          },
        });
    }
    //this.reportService.exportReport(payload, 'OnOff Status');
  }

  exportGatewayStatusReport() {
    let isValid = true;
    this.validationGatewayStatusProject = '';
    this.gatewayStatusvalidation = '';

    if (!this.selectedGatewayStatus) {
      this.gatewayStatusvalidation = 'Please select Status';
      isValid = false;
    }
    if (
      !this.selectedGatewayStatusProject ||
      this.selectedGatewayStatusProject.length === 0
    ) {
      this.validationGatewayStatusProject = 'Please select Projects';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      const selectedProjects =
        this.selectedGatewayStatusProject[0] === 'all'
          ? this.projectsList
              .filter((data: any) => data.id && data.id !== 'all')
              .map((data: any) => data.id)
          : this.selectedGatewayStatusProject;

      const payload = {
        UserId: this.userId,
        ProjectId:
          this.selectedGatewayStatusProject[0] === 'all'
            ? []
            : selectedProjects,
        Status: this.selectedGatewayStatus,
      };

      this.reportService
        .exportReportMeterReadings(payload, 'GatewayStatusReport')
        .subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.isGatewayStatus_Reports_DownloadignInprogress = true;
              this.isGatewayStatus_Reports_DownloadedLinkAvailable = false;
              this.hidePreviouseGatewayStatus_Reports_availableBtn = false;
              this.getLatestGatewayStatusReportStatus('download');
            } else {
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'Report Export',
                res?.message ?? 'Unable to generate gateway status report.',
                SweetAlertIcon.INFO,
              );
            }
          },
          error: (err) => {
            this.loaderService.setLoading(false);
            console.error('Error while exporting gateway status report:', err);
          },
        });
    }
  }

  exportPrepaidMeterOffStatusReport() {
    let isValid = true;
    this.validationPrepaidMeterOffStatusProject = '';
    this.dateRangePrepaidMeterOffStatusValidationMessage = '';

    if (
      !this.selectedPrepaidMeterOffStatusProject ||
      this.selectedPrepaidMeterOffStatusProject.length === 0
    ) {
      this.validationPrepaidMeterOffStatusProject = 'Please select Projects';
      isValid = false;
    }

    if (
      !this.selectedPrepaidMeterOffStatusDateRange ||
      this.selectedPrepaidMeterOffStatusDateRange.length !== 2
    ) {
      this.dateRangePrepaidMeterOffStatusValidationMessage =
        'Please select a date range.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      const from = new Date(
        this.selectedPrepaidMeterOffStatusDateRange[0].getTime() -
          this.selectedPrepaidMeterOffStatusDateRange[0].getTimezoneOffset() *
            60000,
      );
      const to = new Date(
        this.selectedPrepaidMeterOffStatusDateRange[1].getTime() -
          this.selectedPrepaidMeterOffStatusDateRange[1].getTimezoneOffset() *
            60000,
      );

      const selectedProjects =
        this.selectedPrepaidMeterOffStatusProject[0] === 'all'
          ? this.prepaidMeterOffStatus_ProjectsList.filter(
              (data: any) => data.projectId && data.projectId !== 'all',
            ).map((data: any) => data.projectId)
          : this.selectedPrepaidMeterOffStatusProject;

      const payload = {
        UserId: this.userId,
        ProjectId:
          this.selectedPrepaidMeterOffStatusProject[0] === 'all'
            ? []
            : selectedProjects,
        FromDate: from.toISOString().slice(0, 10),
        ToDate: to.toISOString().slice(0, 10),
      };

      this.reportService
        .exportReportMeterReadings(payload, 'PrepaidMeterOffStatusReport')
        .subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.isPrepaidMeterOffStatus_Reports_DownloadignInprogress =
                true;
              this.isPrepaidMeterOffStatus_Reports_DownloadedLinkAvailable =
                false;
              this.hidePreviousePrepaidMeterOffStatus_Reports_availableBtn =
                false;
              this.getLatestPrepaidMeterOffStatusReportStatus('download');
            } else {
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'Report Export',
                res?.message ??
                  'Unable to generate prepaid meter off status report.',
                SweetAlertIcon.INFO,
              );
            }
          },
          error: (err) => {
            this.loaderService.setLoading(false);
            console.error(
              'Error while exporting prepaid meter off status report:',
              err,
            );
          },
        });
    }
  }

  exportScheduledBillingReport() {
    let isValid = true;
    this.monthValidationMessage = '';
    this.billingtypevalidation = '';
    this.validationscheduledBillingProject = '';
    this.dateRangeScheduledBillingValidationMessage = '';

    if (!this.selectedScheduledBillingType) {
      this.billingtypevalidation = 'Please select Billing Type';
      isValid = false;
    }

    if (
      !this.selectedScheduledBillingProject ||
      this.selectedScheduledBillingProject.length === 0
    ) {
      this.validationscheduledBillingProject = 'Please select Projects';
      isValid = false;
    }

    if (this.selectedScheduledBillingType === 'Prepaid') {
      if (
        !this.selectedScheduledBillingDateRange ||
        this.selectedScheduledBillingDateRange.length !== 2
      ) {
        this.dateRangeScheduledBillingValidationMessage =
          'Please select a date range.';
        isValid = false;
      }
    }

    if (this.selectedScheduledBillingType === 'Postpaid') {
      if (
        !this.selectScheduleBillingMonth ||
        this.selectScheduleBillingMonth.length === 0
      ) {
        this.monthValidationMessage = 'Please select a month.';
        isValid = false;
      }
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      let fromDate: string | null = null;
      let toDate: string | null = null;

      if (this.selectedScheduledBillingType === 'Prepaid') {
        const from = new Date(
          this.selectedScheduledBillingDateRange[0].getTime() -
            this.selectedScheduledBillingDateRange[0].getTimezoneOffset() *
              60000,
        );
        const to = new Date(
          this.selectedScheduledBillingDateRange[1].getTime() -
            this.selectedScheduledBillingDateRange[1].getTimezoneOffset() *
              60000,
        );
        fromDate = from.toISOString().slice(0, 10);
        toDate = to.toISOString().slice(0, 10);
      }

      const selectedProjects =
        this.selectedScheduledBillingProject[0] === 'all'
          ? this.Billing_ProjectsList.filter(
              (data: any) => data.projectId && data.projectId !== 'all',
            ).map((data: any) => data.projectId)
          : this.selectedScheduledBillingProject;

      const payload = {
        projectId: selectedProjects,
        projecttype: this.selectedScheduledBillingType,
        month:
          this.selectedScheduledBillingType === 'Postpaid'
            ? this.selectScheduleBillingMonth
            : null,
        fromDate: fromDate,
        toDate: toDate,
        UserId: this.userId,
      };

      console.log('Export Payload:', payload);
      this.reportService
        .exportReportMeterReadings(payload, 'ScheduleBilling')
        .subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.getLatestScheduleBillingReportStatus('download');
              // console.log(response.message); // "Report downloaded successfully."
            } else {
              //  console.log(response.message); // "No Data Found." or any other message
            }
          },
          error: (err) => {
            this.loaderService.setLoading(false);
            console.error('Error while exporting report:', err);
          },
        });
      //this.reportService.exportReport(payload, 'ScheduleBilling');
    }
  }

  onBillingTypeChange(data: any) {
    console.log(this.selectedScheduledBillingType);
    this.selectedScheduledBillingProject = [];
    this.loaderService.setLoading(true);
    this.reportService
      .getProjectBillingType(this.selectedScheduledBillingType)
      .subscribe({
        next: (response: any) => {
          // Handle the response here
          this.loaderService.setLoading(false);
          console.log('Billing Type Response:', response);
          if (response.statusCode == 200) {
            if (response.data.length != 0) {
              this.Billing_ProjectsList = [
                {
                  projectId: 'all',
                  name: 'All Projects',
                },
                ...(response.data || []),
              ];
              this.selectedScheduledBillingProject = ['all'];
              this.updateScheduledBillingMinDate();
            } else {
              this.Billing_ProjectsList = [];
            }
          }
        },
        error: (error) => {
          console.error('Error fetching billing type:', error);
        },
      });
  }

  getPrepaidMeterOffStatusProjects() {
    this.loaderService.setLoading(true);
    this.reportService.getProjectBillingType('Prepaid').subscribe({
      next: (response: any) => {
        this.loaderService.setLoading(false);
        if (response.statusCode == 200) {
          this.prepaidMeterOffStatus_ProjectsList = [
            {
              projectId: 'all',
              name: 'All Projects',
            },
            ...(response.data || []),
          ];
          this.prepaidMeterOffStatus_ProjectsDupList = [
            ...this.prepaidMeterOffStatus_ProjectsList,
          ];
          this.selectedPrepaidMeterOffStatusProject =
            this.prepaidMeterOffStatus_ProjectsList.length > 0 ? ['all'] : [];
          this.updatePrepaidMeterOffStatusProjectStartDates();
          this.updatePrepaidMeterOffStatusMinDate();
        }
      },
      error: (error) => {
        this.loaderService.setLoading(false);
        console.error('Error fetching prepaid projects:', error);
      },
    });
  }
  getLastSixMonths(): void {
    const currentDate = new Date();
    const monthsWithYears: string[] = [];

    for (let i = 0; i < 6; i++) {
      const tempDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1,
      );

      const monthIndex = tempDate.getMonth();
      const monthName = Months[monthIndex]?.name;
      const year = tempDate.getFullYear();

      monthsWithYears.push(`${monthName}-${year}`);
    }

    this.monthsList = monthsWithYears;
    console.log('Months List:', this.monthsList);

    this.dupMonthsList = [...monthsWithYears];
  }

  getLastSixMonthsExcludingCurrent(): void {
    const monthsWithYears: string[] = [];

    const Months = [
      { name: 'January' },
      { name: 'February' },
      { name: 'March' },
      { name: 'April' },
      { name: 'May' },
      { name: 'June' },
      { name: 'July' },
      { name: 'August' },
      { name: 'September' },
      { name: 'October' },
      { name: 'November' },
      { name: 'December' },
    ];

    const currentDate = new Date();
    // Start from the previous month (excluding current month)
    let tempDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1,
      1,
    );

    for (let i = 0; i < 6; i++) {
      const monthIndex = tempDate.getMonth();
      const year = tempDate.getFullYear();
      const monthName = Months[monthIndex].name;

      monthsWithYears.push(`${monthName} - ${year}`);

      // Move to previous month
      tempDate.setMonth(tempDate.getMonth() - 1);
    }

    this.scheduledBillingmonthsList = monthsWithYears;
    this.dupScheduledBillingmonthsList = [...this.scheduledBillingmonthsList];

    console.log(
      'scheduledBillingmonthsList List:',
      this.scheduledBillingmonthsList,
    );
  }

  getLastSixMonthsWithAll(): void {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() - 1; // 0-11

    // Calculate the next 5 months including the current month
    let nextFiveMonths = [];
    for (let i = 0; i < 6; i++) {
      const monthIndex = (currentMonth - i + 12) % 12;
      nextFiveMonths.push(Months[monthIndex]);
    }
    nextFiveMonths = [
      {
        id: 'all',
        name: 'All',
      },
      ...nextFiveMonths,
    ];
    this.monthsListWithAll = nextFiveMonths;
    this.dupMonthsListWithAll = nextFiveMonths;
  }

  getutilityproject() {
    this.reportService.getutilityproject().subscribe({
      next: (res) => {
        if (res.statusCode == 200) {
          this.utilitybyProjectsList = [
            {
              id: 'all',
              name: 'All Projects',
            },
            ...(res.data || []),
          ];
          this.seletedUtilityProject = [this.utilitybyProjectsList[0].id];
          this.projectStartDateById.clear();
          (res.data || []).forEach((item: any) => {
            const parsed = this.parseProjectStartDate(item);
            if (parsed) {
              if (item?.id !== undefined) {
                this.projectStartDateById.set(item.id, parsed);
              }
              if (item?.projectId !== undefined) {
                this.projectStartDateById.set(item.projectId, parsed);
              }
            }
          });
          if (this.projectsList?.length) {
            this.projectsList = this.projectsList.map((p: any) => ({
              ...p,
              startDate:
                p?.startDate ??
                (p?.id !== undefined
                  ? this.projectStartDateById.get(p.id)
                  : undefined),
            }));
            this.projectsDupList = this.projectsList.map((p: any) => ({
              ...p,
            }));
          }
          this.updateSettlementMinDate();
          this.updateOnOffMinDate();
          this.updatePrepaidMeterOffStatusMinDate();
          this.updateHighConsumptionMinDate();
          console.log(res);
        }
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        console.log(err);
      },
    });
  }
  getConsumerByProject() {
    this.reportService.getConsumersByProjects(this.projectId).subscribe({
      next: (response: any) => {
        response.data = [
          {
            id: 'all',
            name: 'All Consumers',
          },
          ...response.data,
        ];
        this.consumersIdsList = response.data;
        console.log(response);
      },
      error: (error) => {
        console.error('Error fetching billing type:', error);
      },
    });
  }

  ngOnDestroy() {
    if (this.downloadMeterSetinterval) {
      clearInterval(this.downloadMeterSetinterval); // Clear the interval
      //   console.log('Interval cleared');
    }
    if (this.statusMeterReadingSetinterval) {
      clearInterval(this.statusMeterReadingSetinterval); // Clear the interval
      //  console.log('Interval cleared');
    }
  }

  getLatestMeterReadingsReportStatus(type: string) {
    this.reportService
      .getLatestMeterReadingsReportStatusService(
        this.userId,
        this.projectId,
        'MeterReading Report',
      )
      .subscribe({
        next: (response: any) => {
          if (response && response?.statusCode == 200) {
            console.log(response);
            this.meterReports = response?.data
              .filter((x: any) => x.reportName === 'MeterReading Report')
              .flatMap((x: any) => x.reports);

            if (this.meterReports.length > 0) {
              this.hidePreviouseMeteravailableBtn = false;
              this.ismeterDownloadignInprogress = this.meterReports.some(
                (x: any) => x.isReportGenerating,
              );
              this.isMeterDownloadedLinkAvailable = this.meterReports.some(
                (x: any) => !x.isReportGenerating,
              );
              this.meterfileUrl = this.meterReports.find(
                (x: any) => !x.isReportGenerating,
              );

              if (
                (type == 'download' || type == 'getStatus') &&
                !this.ismeterDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Completed',
                  'Please Click Generated Report to get excel file',
                  SweetAlertIcon.INFO,
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } else if (
                (type == 'getStatus' || type == 'download') &&
                this.ismeterDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation In Progress',
                  'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
                  SweetAlertIcon.INFO,
                );
              }
            } else {
              this.hidePreviouseMeteravailableBtn = true;
            }
            this.loaderService.setLoading(false);
          }
        },
      });
  }

  downloadPreviousMeterReportFile() {
    if (this.meterfileUrl.status == 'Success') {
      if (this.meterfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.meterfileUrl.name,
          'Meter Reading Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }
  downloadWallet_History_ReportFile() {
    console.log(this.walletHistory_ReportfileUrl);
    if (this.walletHistory_ReportfileUrl.status == 'Success') {
      if (this.walletHistory_ReportfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.walletHistory_ReportfileUrl.name,
          'Wallet History Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }

  downloadWOnOffStatus_ReportFile() {
    console.log(this.onOffStatus_Reports_ReportfileUrl);
    if (this.onOffStatus_Reports_ReportfileUrl.status == 'Success') {
      if (this.onOffStatus_Reports_ReportfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.onOffStatus_Reports_ReportfileUrl.name,
          'OnOff Status Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }
  downloadPrepaidMeterOffStatus_ReportFile() {
    if (this.prepaidMeterOffStatus_Reports_ReportfileUrl.status == 'Success') {
      if (this.prepaidMeterOffStatus_Reports_ReportfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.prepaidMeterOffStatus_Reports_ReportfileUrl.name,
          'Prepaid Meter Off Status Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }
  downloadGatewayStatus_ReportFile() {
    if (this.gatewayStatus_Reports_ReportfileUrl.status == 'Success') {
      if (this.gatewayStatus_Reports_ReportfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.gatewayStatus_Reports_ReportfileUrl.name,
          'Gateway Status Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }
  downloadHighConsumption_ReportFile() {
    if (this.highConsumption_Reports_ReportfileUrl.status == 'Success') {
      if (this.highConsumption_Reports_ReportfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.highConsumption_Reports_ReportfileUrl.name,
          'HighConsumption-Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }
  downloadWScheduleBilling_ReportFile() {
    console.log(this.ScheduleBilling_Reports_ReportfileUrl);
    if (this.ScheduleBilling_Reports_ReportfileUrl.status == 'Success') {
      if (this.ScheduleBilling_Reports_ReportfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.ScheduleBilling_Reports_ReportfileUrl.name,
          'ScheduleBilling-Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }
  downloadPreviousConsumptionReportFile() {
    if (this.consumptionReportfileUrl.status == 'Success') {
      if (this.consumptionReportfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.consumptionReportfileUrl.name,
          this.consumptionReportfileUrl.reportType + ' Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }

  exportHighConsumptionReport() {
    this.highConsumptionProjectValidationMessage = '';
    this.highConsumptionDateRangeValidationMessage = '';

    let isValid = true;

    if (
      !this.selectedHighConsumptionProject ||
      this.selectedHighConsumptionProject.length === 0
    ) {
      this.highConsumptionProjectValidationMessage =
        'Please select at least one Project.';
      isValid = false;
    }

    if (
      !this.highConsumptionDateRange ||
      this.highConsumptionDateRange.length !== 2
    ) {
      this.highConsumptionDateRangeValidationMessage =
        'Please select a date range.';
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    this.loaderService.setLoading(true);

    const fromDate = new Date(
      this.highConsumptionDateRange[0].getTime() -
        this.highConsumptionDateRange[0].getTimezoneOffset() * 60000,
    );
    const toDate = new Date(
      this.highConsumptionDateRange[1].getTime() -
        this.highConsumptionDateRange[1].getTimezoneOffset() * 60000,
    );

    const payload = {
      UserId: this.userId,
      ProjectId:
        this.selectedHighConsumptionProject &&
        this.selectedHighConsumptionProject.length > 0
          ? this.selectedHighConsumptionProject[0] === 'all'
            ? []
            : this.selectedHighConsumptionProject
          : [],
      FromDate: fromDate.toISOString().slice(0, 10),
      ToDate: toDate.toISOString().slice(0, 10),
    };

    this.reportService
      .exportReportMeterReadings(payload, 'HighConsumptionReport')
      .subscribe({
        next: (res) => {
          if (res.statusCode == 200) {
            this.getLatestHighConsumptionReportStatus('download');
          }
        },
        error: (err) => {
          this.loaderService.setLoading(false);
          console.error('Error while exporting report:', err);
        },
      });
  }

  downloadPreviousDeviceCommunicationReportFile() {
    if (this.deviceCommunicationfileUrl.status == 'Success') {
      if (this.deviceCommunicationfileUrl.name) {
        this.sharedService.downloadUtilityFiles(
          this.deviceCommunicationfileUrl.name,
          'Device Communication Report.xlsx',
        );
      } else {
        this.sharedService.showMessageDialog(
          'Report Export ',
          'No Data found in between dates.',
          SweetAlertIcon.INFO,
        );
      }
    } else {
      this.sharedService.showMessageDialog(
        'Report Export Failed',
        'The report failed to export. Please try again.',
        SweetAlertIcon.ERROR,
      );
    }
  }

  getAllFlatNumbers() {
    this.loaderService.setLoading(true);
    this.reportService.getFlatNumbersByProjectId(this.projectId).subscribe({
      next: (response) => {
        if (response && response?.statusCode == 200) {
          response.data = [
            {
              id: 'all',
              flatNo: 'All Flats',
            },
            ...response.data,
          ];

          this.flatnumbersList = response?.data;
          this.flatnumbersListDup = response?.data;
          this.walletBanlanceFalttemList = response?.data;
          this.loaderService.setLoading(false);
        }
      },
    });
  }

  dashboradNavigationdetails() {
    console.log('jdkjsdjsdkja');
    this.selectedProject = [this.projectsList[0].id];
    this.selectedSettlementProject = [this.projectsList[0].id];
    this.selectedUtility = [this.utilityList[0].id];
    this.selectedBatteryLevel = 'all';
    this.selectedOnOffStatusProject = [this.projectsList[0].id];
    console.log(this.consumptionlistFromdashboard);
    if (Object.keys(this.consumptionlistFromdashboard).length > 0) {
      /* if (
        ['EB', 'DG'].includes(this.consumptionlistFromdashboard.UtilityType)
      ) {
         console.log(this.utilityList);
        this.consumptionlistFromdashboard.UtilityType = 'Electricity';

        this.consumptionlistFromdashboard['UtilityTypeArry'] = ['Electricity','TriSource'];

      } */
      if (
        ['EB', 'DG'].includes(this.consumptionlistFromdashboard.UtilityType)
      ) {
        // Allowed names
        const allowedUtilities = ['Electricity', 'TriSource'];

        // Match from utilityList
        const matched = this.utilityList
          .filter((u: { name: string }) => allowedUtilities.includes(u.name))
          .map((u: { name: any }) => u.name);

        // Add UtilityTypeArray at the same object level
        this.consumptionlistFromdashboard.UtilityTypeArray = Array.from(
          new Set(matched),
        );

        console.log(this.consumptionlistFromdashboard.UtilityTypeArray);
      }
      if (this.consumptionlistFromdashboard.type == 'top5Consumption') {
        console.log(this.consumptionlistFromdashboard);
        // Assuming the startDate and endDate are already Date objects
        this.consumptionlistFromdashboard.date.startDate = new Date(
          this.consumptionlistFromdashboard.date.startDate,
        );
        this.consumptionlistFromdashboard.date.endDate = new Date(
          this.consumptionlistFromdashboard.date.endDate,
        );
        this.consumption_selectedRange = 'Day Wise';
        // Format the dates as 'yyyy-MM-dd'
        let startDateFormatted =
          this.consumptionlistFromdashboard.date.startDate
            .toISOString()
            .split('T')[0];
        let endDateFormatted = this.consumptionlistFromdashboard.date.endDate
          .toISOString()
          .split('T')[0];

        // Now set the formatted date back to your object
        this.consumptionlistFromdashboard.date.startDate = startDateFormatted;
        this.consumptionlistFromdashboard.date.endDate = endDateFormatted;

        if (this.consumptionlistFromdashboard.UtilityTypeArray?.length > 0) {
          // ✅ Case 1: UtilityTypeArray exists
          this.consumption_selectedUtility = this.utilityList
            .filter((u: any) =>
              this.consumptionlistFromdashboard.UtilityTypeArray.includes(
                u.name,
              ),
            )
            .map((u: any) => u.id);
        } else {
          // ✅ Case 2: Fallback to single UtilityType
          this.utilityList.forEach((item: any) => {
            if (item.name === this.consumptionlistFromdashboard.UtilityType) {
              this.consumption_selectedUtility = [item.id];
              this.dailyconsumption_selectedUtility = [item.id];
            }
          });
        }

        //console.log(this.consumptionlistFromdashboard.date);

        /* this.utilityList.forEach((item: any) => {
          if (item.name == this.consumptionlistFromdashboard.UtilityType) {
            this.consumption_selectedUtility = [item.id];
            this.dailyconsumption_selectedUtility = [item.id];
          }
        }); */
        this.consumptionDateRange = [
          new Date(this.consumptionlistFromdashboard.date.startDate),
          new Date(this.consumptionlistFromdashboard.date.endDate),
        ];
        console.log(this.consumptionlistFromdashboard.flatNo);
        let FlatNo = this.consumptionlistFromdashboard.flatNo;
        console.log(this.flatnumbersList);
        console.log(FlatNo);
        this.flatnumbersList.forEach((data: any) => {
          if (data.flatNo == this.consumptionlistFromdashboard.flatNo) {
            console.log(data);
            this.Consumption_selectedFlatNumber = [data.id];
            // console.log(this.Consumption_selectedFlatNumber);
          }
        });
      } else if (
        this.consumptionlistFromdashboard.type == 'dashboardConsumption'
      ) {
        console.log(this.consumptionlistFromdashboard.date);
        this.consumption_selectedRange = 'Day Wise';
        this.consumptionDateRange = [
          new Date(this.consumptionlistFromdashboard.date.start),
          new Date(this.consumptionlistFromdashboard.date.end),
        ];
        if (this.consumptionlistFromdashboard.UtilityTypeArray?.length > 0) {
          // ✅ Case 1: UtilityTypeArray exists
          this.consumption_selectedUtility = this.utilityList
            .filter((u: any) =>
              this.consumptionlistFromdashboard.UtilityTypeArray.includes(
                u.name,
              ),
            )
            .map((u: any) => u.id);
        } else {
          // ✅ Case 2: Fallback to single UtilityType
          this.utilityList.forEach((item: any) => {
            if (item.name === this.consumptionlistFromdashboard.UtilityType) {
              this.consumption_selectedUtility = [item.id];
              this.dailyconsumption_selectedUtility = [item.id];
            }
          });
        }
        /*  this.utilityList.forEach((item: any) => {
          if (item.name == this.consumptionlistFromdashboard.UtilityType) {
            this.consumption_selectedUtility = [item.id];
            this.dailyconsumption_selectedUtility = [item.id];
          }
        }); */
      } else if (this.consumptionlistFromdashboard.type == 'Consumption') {
        console.log(this.consumptionlistFromdashboard);
        this.consumption_selectedRange = 'Day Wise';
        if (this.consumptionlistFromdashboard.UtilityTypeArray?.length > 0) {
          // ✅ Case 1: UtilityTypeArray exists
          this.consumption_selectedUtility = this.utilityList
            .filter((u: any) =>
              this.consumptionlistFromdashboard.UtilityTypeArray.includes(
                u.name,
              ),
            )
            .map((u: any) => u.id);
        } else {
          // ✅ Case 2: Fallback to single UtilityType
          this.utilityList.forEach((item: any) => {
            if (item.name === this.consumptionlistFromdashboard.UtilityType) {
              this.consumption_selectedUtility = [item.id];
              this.dailyconsumption_selectedUtility = [item.id];
            }
          });
        }

        /*  this.utilityList.forEach((item: any) => {
          if (item.name == this.consumptionlistFromdashboard.UtilityType) {
            this.consumption_selectedUtility = [item.id];
            this.dailyconsumption_selectedUtility = [item.id];
          }
        }); */

        //  console.log(this.consumptionlistFromdashboard);
        const transformData = (data: any) => {
          const [timestamp, amount] = data.value; // Destructure value array

          // Create a new object
          return {
            UtilityType: data.UtilityType,
            flag: data.flag,
            value: amount,
            date: new Date(timestamp).toISOString().split('T')[0], // Format date as YYYY-MM-DD
          };
        };
        const dt = transformData(this.consumptionlistFromdashboard);
        this.consumptionDateRange = [new Date(dt.date), new Date(dt.date)];
      } else if (this.consumptionlistFromdashboard.type == 'Admin_Meter') {
        const today = new Date();
        this.deviceCommunicationDateRange[0] = today;
        this.deviceCommunicationDateRange[1] = today;
        console.log(
          'utukdhskhdskdsdksadksada---->',
          this.consumptionlistFromdashboard,
        );
        this.deviceCommunication_selectedUtility = [
          this.consumptionlistFromdashboard?.utility,
        ];
        this.isDeviceCommunication = true;
        switch (this.consumptionlistFromdashboard.value) {
          case 'Inactive':
            this.selectActivationStatus = 'In-active';
            this.selectedCommnunicationStatus = 'No';
            break;
          case 'MCB Off':
            this.selecteddeviceCommunicationMcb = 'Off';
            break;
          case 'Communicating':
            this.selectedCommnunicationStatus = 'Yes';
            this.selectActivationStatus = 'Active';
            break;
          case 'Non Communicating':
            this.selectedValve_Status = 'Off';
            this.selectedCommnunicationStatus = 'No';
            this.selectActivationStatus = 'Active';

            break;
        }
      } else if (this.consumptionlistFromdashboard.type == 'Wallet History') {
        this.sharedService.showMessageDialog(
          '',
          'Only the data from the last 3 months will be included in the report download.',
          SweetAlertIcon.INFO,
        );
        this.iswalleHistoryReportOpen = true;
        this.walletHistoryDateRange[0] = new Date(
          this.consumptionlistFromdashboard.dateRange.startDate + 'T00:00:00',
        );
        this.walletHistoryDateRange[1] = new Date(
          this.consumptionlistFromdashboard.dateRange.endDate + 'T00:00:00',
        );
      } else if (
        this.consumptionlistFromdashboard.type == 'Total Wallet Recharge'
      ) {
        this.sharedService.showMessageDialog(
          '',
          'Only the data from the last 6 months will be included in the report download.',
          SweetAlertIcon.INFO,
        );
        this.iswalletBalnceReport = true;

        const today = new Date();
        this.walletBalanceDateRange[0] = new Date(
          this.consumptionlistFromdashboard.projectStartDate.startDate,
        );
        this.walletBalanceDateRange[1] = new Date(
          this.consumptionlistFromdashboard.projectStartDate.endDate,
        );
         this.updateWalletBalanceMinDate(
    this.consumptionlistFromdashboard?.projectStartDate?.startDate,
  );
        //this.walletBalanceDateRange[1] = today;
        this.selected_walletbalance = ['Success'];
      } else if (
        this.consumptionlistFromdashboard.type == 'Total Wallet History'
      ) {
        this.sharedService.showMessageDialog(
          '',
          'Only the data from the last 3 months will be included in the report download.',
          SweetAlertIcon.INFO,
        );
        console.log(this.consumptionlistFromdashboard);
        this.iswalleHistoryReportOpen = true; // Wallet History Reports
        this.iswalletBalnceReport = false; // Consumer wallet Reports
        const today = new Date();
        this.walletHistoryDateRange[0] = new Date(
          this.consumptionlistFromdashboard.projectStartDate.startDate,
        );
        this.walletHistoryDateRange[1] = new Date(
          this.consumptionlistFromdashboard.projectStartDate.endDate,
        );
        // this.walletHistoryDateRange[1] = today;
      }
      this.loaderService.setLoading(false);
    }
  }

  getAllConfigData(): void {
    let payload = ['utilities', 'projects', 'statementMonths'];
    this.loaderService.setLoading(true);
    this.sharedService.getAllConfigData(payload).subscribe((data) => {
      this.loaderService.setLoading(false);
      if (
        data.statusCode == 200 &&
        data.message == 'Config data retrieved successfully.'
      ) {
        this.configData = data.data;
        this.configData.utilities = [
          {
            id: 'all',
            name: 'All Utilities',
          },
          ...(data.data?.utilities || []), // Use an empty array if data.data.utilities is undefined
        ];

        this.configData.projects = [
          {
            id: 'all',
            name: 'All Projects',
          },
          ...(data.data?.projects || []),
        ];

        this.projectsDupList = [
          // {
          //   id: 'all',
          //   name: 'All Projects',
          // },
          ...this.configData?.projects,
        ];

        this.projectsList = [
          // {
          //   id: 'all',
          //   name: 'All Projects',
          // },
          ...this.configData?.projects,
        ];
        this.selectedHighConsumptionProject = this.projectsList?.length
          ? [this.projectsList[0].id]
          : [];
        this.selectedGatewayStatusProject = this.projectsList?.length
          ? [this.projectsList[0].id]
          : [];
       this.walletHistoryUtilityList = [...this.configData?.utilities];
        this.utilityList = this.filterReportUtilityList([
          ...this.configData?.utilities,
        ]);

         this.utilitylistDup = [...this.utilityList];

        this.BatteryLevelutilityList = this.configData?.utilities.filter(
          (item: any) =>
            item.name !== 'Electricity' &&
             item.name.toLowerCase() !== 'trisource' &&
            item.name.toLowerCase() !== 'ev',
)
        this.BatteryLevelutilityListDup = [
          ...this.configData?.utilities.filter(
            (item: any) =>
              item.name !== 'Electricity' &&
              item.name.toLowerCase() !== 'trisource' &&
              item.name.toLowerCase() !== 'ev'
          ),
        ];
        const currentProject = (data.data?.projects || []).find(
          (project: any) =>
            project?.id === this.projectId ||
            project?.projectId === this.projectId,
        );
        this.setStatementMonthsList(data.data, currentProject);
        this.updateBillGenerationMinDate(currentProject);
        this.dashboradNavigationdetails();

        // console.log(this.utilityList)
      }
    });
  }

  public onProjectSelectionSchedulingReportChange(searchTerm: any): void {
    this.updateScheduledBillingMinDate();
  }

  public onProjectSettlementFilterChange(searchTerm: any): void {
    if (typeof searchTerm === 'string') {
      const contains =
        (value: string) => (item: { name: string; id: number }) =>
          item.name.toLowerCase().includes(value.toLowerCase());
      this.projectsList = this.projectsDupList.filter(contains(searchTerm));
      return;
    }
    this.updateSettlementMinDate();
  }

  public onProjectFilterChange(searchTerm: any): void {
    const contains = (value: string) => (item: { name: string; id: number }) =>
      item.name.toLowerCase().includes(value.toLowerCase());

    this.utilitybyProjectsList = this.projectsDupList.filter(
      contains(searchTerm),
    );
  }

  public onHighConsumptionProjectFilterChange(searchTerm: any): void {
    if (typeof searchTerm === 'string') {
      const contains =
        (value: string) => (item: { name: string; id: number }) =>
          item.name.toLowerCase().includes(value.toLowerCase());
      this.projectsList = this.projectsDupList.filter(contains(searchTerm));
      return;
    }
    this.updateHighConsumptionMinDate();
  }

  public onOffStatusProjectFilterChange(searchTerm: any): void {
    if (typeof searchTerm === 'string') {
      const contains =
        (value: string) => (item: { name: string; id: number }) =>
          item.name.toLowerCase().includes(value.toLowerCase());
      this.projectsList = this.projectsDupList.filter(contains(searchTerm));
      return;
    }
    this.updateOnOffMinDate();
  }

  public prepaidMeterOffStatusProjectFilterChange(searchTerm: any): void {
    if (typeof searchTerm === 'string') {
      const contains =
        (value: string) => (item: { name: string; projectId: number }) =>
          item.name.toLowerCase().includes(value.toLowerCase());
      this.prepaidMeterOffStatus_ProjectsList =
        this.prepaidMeterOffStatus_ProjectsDupList.filter(
          contains(searchTerm),
        );
      return;
    }
    this.updatePrepaidMeterOffStatusMinDate();
  }

  public gatewayStatusProjectFilterChange(searchTerm: any): void {
    if (typeof searchTerm === 'string') {
      const contains =
        (value: string) => (item: { name: string; id: number }) =>
          item.name.toLowerCase().includes(value.toLowerCase());
      this.projectsList = this.projectsDupList.filter(contains(searchTerm));
    }
  }

  public onUtilityFilterChange(searchTerm: any): void {
    const contains = (value: string) => (item: { name: string; id: number }) =>
      item.name.toLowerCase().includes(value.toLowerCase());

    this.utilityList = this.configData?.utilities.filter(contains(searchTerm));
  }

  onUtilityValueChange(value: any): void {
    if (value.length > 0) {
      let selectAlldata = value.filter((x: any) => {
        return x.id == 'selectAll';
      });
      if (selectAlldata.length > 0) {
        this.selectedUtility = this.configData?.utilities;
      }
    } else {
      this.selectedUtility = [];
      this.isUtilityChecked = false;
    }
  }

  // onBatteryValueChange(value: any): void {
  //   console.log('valueChange', value);
  //   if (value.length > 0) {
  //     let selectAlldata = value.filter((x: any) => {
  //       return x.id == 'selectAll';
  //     });
  //     if (selectAlldata.length > 0) {
  //       this.selectedBatteryLevel = this.batteryLevel;
  //     }
  //   } else {
  //     this.selectedBatteryLevel = [];
  //     this.isBatteryChecked = false;
  //   }
  // }

  export() {
    // Reset validation messages
    console.log(this.seletedUtilityProject.length);

    this.utilityValidationMessage = '';
    this.dailyutilityValidationMessage = '';
    this.ProjectsValidationMessage = '';

    let isValid = true;

    if (!this.selectedUtility || this.selectedUtility.length === 0) {
      this.utilityValidationMessage = 'Please select at least one utility.';
      isValid = false;
    }

    if (
      !this.seletedUtilityProject ||
      this.seletedUtilityProject.length === 0
    ) {
      console.log(this.seletedUtilityProject.length);
      this.ProjectValidationMessage = 'Please select at least one Project.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      let payload = {
        BatteryStatus: this.selectedBatteryLevel,
        Utility:
          this.selectedUtility && this.selectedUtility.length > 0
            ? this.selectedUtility[0] === 'all'
              ? null
              : this.selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectIds:
          this.seletedUtilityProject && this.seletedUtilityProject.length > 0
            ? this.seletedUtilityProject[0] === 'all'
              ? null
              : this.seletedUtilityProject
            : null, // Handling cases where selectedUtility is empty or "all"
      };
      this.reportService.exportReport(payload, 'BatteryStatus');
    }
  }

  onInputChange() {
    // Clear individual validation messages when user interacts

    if (this.selectedUtility.length > 0) {
      this.utilityValidationMessage = '';
    }
    if (this.activationDateRange.length > 0) {
      this.dateRangeValidationMessage = '';
    }
  }

  onValueChange(selectedDate: Date | undefined) {
    if (selectedDate) {
      // console.log("Selected Year:", selectedDate.getFullYear());
      // console.log("Selected Month:", selectedDate.getMonth() + 1); // Months are 0-indexed

      // After selecting a year, switch to month selection
      this.datePickerConfigwithYearSelection = {
        ...this.datePickerConfigwithYearSelection,
        minMode: 'month',
        minDate: this.getLastSixMonthsDate(), // Ensure only last 6 months can be selected
        maxDate: new Date(),
      };
    }
  }

  getLastSixMonthsDate(): Date {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth() - 6, 1); // First day of 6 months ago
  }

  exportSettlemet() {
    let isValid = true;
    this.ProjectSettlmentValidationMessage = '';
    this.dateRangeSettlementValidationMessage = '';
    if (this.settlemetDateRange.length != 2) {
      this.dateRangeSettlementValidationMessage = 'Please select a date range.';
      isValid = false;
    }
    if (
      !this.selectedSettlementProject ||
      this.selectedSettlementProject.length === 0
    ) {
      this.ProjectSettlmentValidationMessage =
        'Please select at least one Project.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      const fromDate = new Date(
        this.settlemetDateRange[0].getTime() -
          this.settlemetDateRange[0].getTimezoneOffset() * 60000,
      );
      const toDate = new Date(
        this.settlemetDateRange[1].getTime() -
          this.settlemetDateRange[1].getTimezoneOffset() * 60000,
      );

      let payload = {
        fromDate: fromDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        toDate: toDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        projectId:
          this.selectedSettlementProject == 'all'
            ? null
            : this.selectedSettlementProject,
      };
      this.reportService.exportReport(payload, 'Settlment');
    }
  }

  exportActionStatus() {
    this.utilityValidationMessage = '';
    this.dateRangeValidationMessage = '';

    let isValid = true;

    if (!this.selectedUtility || this.selectedUtility.length === 0) {
      this.utilityValidationMessage = 'Please select at least one utility.';
      isValid = false;
    }

    // if (this.activationDateRange.length === 0) {
    //   this.dateRangeValidationMessage = 'Please select a date range.';
    //   isValid = false;
    // }

    this.submittedActivationStatus = true;
    if (isValid) {
      let fromDate = null;
      let toDate = null;

      this.submittedActivationStatus = false;
      this.loaderService.setLoading(true);

      if (this.activationDateRange.length > 0) {
        fromDate = new Date(
          this.activationDateRange[0].getTime() -
            this.activationDateRange[0].getTimezoneOffset() * 60000,
        );
        toDate = new Date(
          this.activationDateRange[1].getTime() -
            this.activationDateRange[1].getTimezoneOffset() * 60000,
        );
      }

      let payload = {
        Active: this.select_Status,
        fromDate: fromDate ? fromDate.toISOString().slice(0, 10) : null, // "YYYY-MM-DD" or null
        toDate: toDate ? toDate.toISOString().slice(0, 10) : null,
        utilityMasterId:
          this.selectedUtility && this.selectedUtility.length > 0
            ? this.selectedUtility[0] === 'all'
              ? null
              : this.selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
      };
      this.reportService.exportReport(payload, 'activation');
    }
  }

  exportConsumptionReport() {
    this.utilityConsumptionValidationMessage = ''; // Resetting utility validation message
    this.dateRangeValidationMessage = ''; // Resetting date range validation message
    // this.flatNumberValidationMessage = ''; // Resetting flat number validation message

    let isValid = true;
    console.log(this.consumption_selectedUtility.length);
    // Validate selected utilities
    if (this.consumption_selectedUtility.length === 0) {
      this.utilityConsumptionValidationMessage =
        'Please select at least one utility.';
      isValid = false;
    }
    if (this.consumption_selectedRange == '') {
      this.consumptionDateRangeValidationMessage = 'Please select Range.';
      isValid = false;
    } else {
      this.consumptionDateRangeValidationMessage = '';
    }

    // Validate selected date range
    if (this.consumptionDateRange.length != 2) {
      this.dateRangeValidationMessage = 'Please select a date range.';
      isValid = false;
    } else {
      this.dateRangeValidationMessage = '';
    }

    // Validate selected flat numbers
    /*  if (!this.Consumption_selectedFlatNumber || this.Consumption_selectedFlatNumber.length === 0) {
       this.flatNumberValidationMessage = 'Please select at least one flat number.';
       isValid = false;
     } */

    if (isValid) {
      this.loaderService.setLoading(true);

      const fromDate = new Date(
        this.consumptionDateRange[0].getTime() -
          this.consumptionDateRange[0].getTimezoneOffset() * 60000,
      );
      const toDate = new Date(
        this.consumptionDateRange[1].getTime() -
          this.consumptionDateRange[1].getTimezoneOffset() * 60000,
      );

      let payload = {
        consumption_Range: this.consumption_selectedRange,
        fromDate: fromDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        toDate: toDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        utilityMasterId:
          this.consumption_selectedUtility &&
          this.consumption_selectedUtility.length > 0
            ? this.consumption_selectedUtility[0] === 'all'
              ? null
              : this.consumption_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
        residentialUnitId:
          this.Consumption_selectedFlatNumber &&
          this.Consumption_selectedFlatNumber.length > 0
            ? this.Consumption_selectedFlatNumber[0] === 'all'
              ? null
              : this.Consumption_selectedFlatNumber
            : null,
        userid: this.userId,
      };
      // this.reportService.exportReport(payload, 'consumption');

      this.reportService
        .exportReportMeterReadings(payload, 'consumption')
        .subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.getLatestConsumptionReadingsReportStatus('download');
              // console.log(response.message); // "Report downloaded successfully."
            } else {
              //  console.log(response.message); // "No Data Found." or any other message
            }
          },
          error: (err) => {
            this.loaderService.setLoading(false);
            console.error('Error while exporting report:', err);
          },
        });
      /* .subscribe(
          (response: any) => {
            if (response.statusCode == 200) {
              this.getLatestConsumptionReadingsReportStatus('download');
              // console.log(response.message); // "Report downloaded successfully."
            } else {
              //  console.log(response.message); // "No Data Found." or any other message
            }
          },
          (error: any) => {
            console.error('Error while exporting report:', error);
          }
        ); */
    }
  }
  getLatestConsumptionReadingsReportStatus(type: string) {
    this.reportService
      .getLatestMeterReadingsReportStatusService(
        this.userId,
        this.projectId,
        'Consumption-Report',
      )
      .subscribe({
        next: (response: any) => {
          if (response && response?.statusCode == 200) {
            console.log(response);
            this.consumptionReports = response?.data
              .filter((x: any) => x.reportName === 'Consumption-Report')
              .flatMap((x: any) => x.reports);
            /*  const hasFailedStatus = this.deviceCommunicationReports.some(
              (item) => item.status === 'Failed'
            ); */

            if (this.consumptionReports.length > 0) {
              this.hidePreviouseConsumptionavailableBtn = false;
              this.isConsumptionDownloadignInprogress =
                this.consumptionReports.some((x: any) => x.isReportGenerating);
              this.isConsumptionDownloadedLinkAvailable =
                this.consumptionReports.some((x: any) => !x.isReportGenerating);
              console.log(this.isConsumptionDownloadedLinkAvailable);
              this.consumptionReportfileUrl = this.consumptionReports.find(
                (x: any) => !x.isReportGenerating,
              );

              if (
                (type == 'download' || type == 'getStatus') &&
                !this.isConsumptionDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Completed',
                  'Please Click Generated Report to get excel file',
                  SweetAlertIcon.INFO,
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } else if (
                /* else if (
                hasFailedStatus &&
                !this.isDeviceCommunicationDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Failed',
                  'Please regenerate the report to download the Excel file',
                  SweetAlertIcon.ERROR
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } */
                (type == 'getStatus' || type == 'download') &&
                this.isConsumptionDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation In Progress',
                  'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
                  SweetAlertIcon.INFO,
                );
              }
            } else {
              this.hidePreviouseConsumptionavailableBtn = true;
            }
            this.loaderService.setLoading(false);
          }
        },
      });
  }
  getLatestWalletHistoryReportStatus(type: string) {
    this.reportService
      .getLatestMeterReadingsReportStatusService(
        this.userId,
        this.projectId,
        'WalletHistory-Report',
      )
      .subscribe({
        next: (response: any) => {
          if (response && response?.statusCode == 200) {
            console.log(response);
            this.walletHistory_Reports = response?.data
              .filter((x: any) => x.reportName === 'WalletHistory-Report')
              .flatMap((x: any) => x.reports);

            if (this.walletHistory_Reports.length > 0) {
              this.hidePreviousewalletHistory_availableBtn = false;
              this.iswalletHistory_DownloadignInprogress =
                this.walletHistory_Reports.some(
                  (x: any) => x.isReportGenerating,
                );
              this.iswalletHistory_DownloadedLinkAvailable =
                this.walletHistory_Reports.some(
                  (x: any) => !x.isReportGenerating,
                );
              console.log(this.iswalletHistory_DownloadedLinkAvailable);
              this.walletHistory_ReportfileUrl =
                this.walletHistory_Reports.find(
                  (x: any) => !x.isReportGenerating,
                );

              if (
                (type == 'download' || type == 'getStatus') &&
                !this.iswalletHistory_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Completed',
                  'Please Click Generated Report to get excel file',
                  SweetAlertIcon.INFO,
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } else if (
                /* else if (
                hasFailedStatus &&
                !this.isDeviceCommunicationDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Failed',
                  'Please regenerate the report to download the Excel file',
                  SweetAlertIcon.ERROR
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } */
                (type == 'getStatus' || type == 'download') &&
                this.iswalletHistory_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation In Progress',
                  'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
                  SweetAlertIcon.INFO,
                );
              }
            } else {
              this.hidePreviousewalletHistory_availableBtn = true;
            }
            this.loaderService.setLoading(false);
          }
        },
      });
  }

  getLatestONOFFStatusReportStatus(type: string) {
    this.reportService
      .getLatestReportStatusService(this.userId, 'OnOffStatus-Report')
      .subscribe({
        next: (response: any) => {
          if (response && response?.statusCode == 200) {
            console.log(response);
            this.onOffStatus_Reports = response?.data
              .filter((x: any) => x.reportName === 'OnOffStatus-Report')
              .flatMap((x: any) => x.reports);

            if (this.onOffStatus_Reports.length > 0) {
              this.hidePreviouseonOffStatus_Reports_availableBtn = false;
              this.isonOffStatus_Reports_DownloadignInprogress =
                this.onOffStatus_Reports.some((x: any) => x.isReportGenerating);
              this.isonOffStatus_Reports_DownloadedLinkAvailable =
                this.onOffStatus_Reports.some(
                  (x: any) => !x.isReportGenerating,
                );
              console.log(this.isonOffStatus_Reports_DownloadedLinkAvailable);
              this.onOffStatus_Reports_ReportfileUrl =
                this.onOffStatus_Reports.find(
                  (x: any) => !x.isReportGenerating,
                );

              if (
                (type == 'download' || type == 'getStatus') &&
                !this.isonOffStatus_Reports_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Completed',
                  'Please Click Generated Report to get excel file',
                  SweetAlertIcon.INFO,
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } else if (
                /* else if (
                hasFailedStatus &&
                !this.isDeviceCommunicationDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Failed',
                  'Please regenerate the report to download the Excel file',
                  SweetAlertIcon.ERROR
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } */
                (type == 'getStatus' || type == 'download') &&
                this.isonOffStatus_Reports_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation In Progress',
                  'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
                  SweetAlertIcon.INFO,
                );
              }
            } else {
              this.hidePreviouseonOffStatus_Reports_availableBtn = true;
            }
            this.loaderService.setLoading(false);
          }
        },
      });
  }

  getLatestPrepaidMeterOffStatusReportStatus(type: string) {
    forkJoin(
      this.prepaidMeterOffStatusReportNames.map((reportName) =>
        this.reportService
          .getLatestReportStatusService(this.userId, reportName)
          .pipe(catchError(() => of(null))),
      ),
    ).subscribe({
      next: (responses: any[]) => {
        const successfulResponses = responses.filter(
          (response: any) => response && response?.statusCode == 200,
        );

        if (successfulResponses.length === 0) {
          this.loaderService.setLoading(false);
          return;
        }

        this.prepaidMeterOffStatus_Reports = successfulResponses
          .flatMap((response: any) => response?.data ?? [])
          .filter((x: any) =>
            this.isPrepaidMeterOffStatusReportName(x.reportName),
          )
          .flatMap((x: any) => x.reports ?? []);

        if (this.prepaidMeterOffStatus_Reports.length > 0) {
          this.hidePreviousePrepaidMeterOffStatus_Reports_availableBtn = false;
          this.isPrepaidMeterOffStatus_Reports_DownloadignInprogress =
            this.prepaidMeterOffStatus_Reports.some(
              (x: any) => x.isReportGenerating,
            );
          this.isPrepaidMeterOffStatus_Reports_DownloadedLinkAvailable =
            this.prepaidMeterOffStatus_Reports.some(
              (x: any) => !x.isReportGenerating,
            );
          this.prepaidMeterOffStatus_Reports_ReportfileUrl =
            this.prepaidMeterOffStatus_Reports.find(
              (x: any) => !x.isReportGenerating,
            );

          if (
            (type == 'download' || type == 'getStatus') &&
            !this.isPrepaidMeterOffStatus_Reports_DownloadignInprogress
          ) {
            this.sharedService.showMessageDialog(
              'Report Generation Completed',
              'Please Click Generated Report to get excel file',
              SweetAlertIcon.INFO,
            );
          } else if (
            (type == 'getStatus' || type == 'download') &&
            this.isPrepaidMeterOffStatus_Reports_DownloadignInprogress
          ) {
            this.sharedService.showMessageDialog(
              'Report Generation In Progress',
              'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
              SweetAlertIcon.INFO,
            );
          }
        } else {
          this.hidePreviousePrepaidMeterOffStatus_Reports_availableBtn = true;
          this.isPrepaidMeterOffStatus_Reports_DownloadignInprogress = false;
          this.isPrepaidMeterOffStatus_Reports_DownloadedLinkAvailable = false;
          if (type == 'download' || type == 'getStatus') {
            this.sharedService.showMessageDialog(
              'Report Generation In Progress',
              'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generate Report"',
              SweetAlertIcon.INFO,
            );
          }
        }
        this.loaderService.setLoading(false);
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        console.error(
          'Error while checking prepaid meter off status report:',
          err,
        );
      },
    });
  }

  private isPrepaidMeterOffStatusReportName(reportName: any): boolean {
    const normalizedReportName = this.normalizeReportName(reportName);
    return this.prepaidMeterOffStatusReportNames.some(
      (name) => this.normalizeReportName(name) === normalizedReportName,
    );
  }

  getLatestGatewayStatusReportStatus(type: string) {
    forkJoin(
      this.gatewayStatusReportNames.map((reportName) =>
        this.reportService.getLatestReportStatusService(this.userId, reportName),
      ),
    ).subscribe({
      next: (responses: any[]) => {
        const successfulResponses = responses.filter(
          (response: any) => response && response?.statusCode == 200,
        );

        if (successfulResponses.length === 0) {
          this.loaderService.setLoading(false);
          return;
        }

        this.gatewayStatus_Reports = successfulResponses
          .flatMap((response: any) => response?.data ?? [])
          .filter((x: any) => this.isGatewayStatusReportName(x.reportName))
          .flatMap((x: any) => x.reports ?? []);

        if (this.gatewayStatus_Reports.length > 0) {
          this.hidePreviouseGatewayStatus_Reports_availableBtn = false;
          this.isGatewayStatus_Reports_DownloadignInprogress =
            this.gatewayStatus_Reports.some(
              (x: any) => x.isReportGenerating,
            );
          this.isGatewayStatus_Reports_DownloadedLinkAvailable =
            this.gatewayStatus_Reports.some(
              (x: any) => !x.isReportGenerating,
            );
          this.gatewayStatus_Reports_ReportfileUrl =
            this.gatewayStatus_Reports.find(
              (x: any) => !x.isReportGenerating,
            );

          if (
            (type == 'download' || type == 'getStatus') &&
            !this.isGatewayStatus_Reports_DownloadignInprogress
          ) {
            this.sharedService.showMessageDialog(
              'Report Generation Completed',
              'Please Click Generated Report to get excel file',
              SweetAlertIcon.INFO,
            );
          } else if (
            (type == 'getStatus' || type == 'download') &&
            this.isGatewayStatus_Reports_DownloadignInprogress
          ) {
            this.sharedService.showMessageDialog(
              'Report Generation In Progress',
              'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
              SweetAlertIcon.INFO,
            );
          }
        } else {
          this.hidePreviouseGatewayStatus_Reports_availableBtn =
            type === 'initcheck';
          this.isGatewayStatus_Reports_DownloadignInprogress =
            type !== 'initcheck';
          this.isGatewayStatus_Reports_DownloadedLinkAvailable = false;
          if (type == 'download' || type == 'getStatus') {
            this.sharedService.showMessageDialog(
              'Report Generation In Progress',
              'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
              SweetAlertIcon.INFO,
            );
          }
        }
        this.loaderService.setLoading(false);
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        console.error('Error while checking gateway status report:', err);
      },
    });
  }

  private isGatewayStatusReportName(reportName: any): boolean {
    const normalizedReportName = this.normalizeReportName(reportName);
    return this.gatewayStatusReportNames.some(
      (name) => this.normalizeReportName(name) === normalizedReportName,
    );
  }

  private normalizeReportName(reportName: any): string {
    return `${reportName ?? ''}`.replace(/[\s-]/g, '').toLowerCase();
  }

  getLatestHighConsumptionReportStatus(type: string) {
    this.reportService
      .getLatestReportStatusService(this.userId, 'HighConsumption-Report')
      .subscribe({
        next: (response: any) => {
          if (response && response?.statusCode == 200) {
            this.highConsumption_Reports = response?.data
              .filter((x: any) => x.reportName === 'HighConsumption-Report')
              .flatMap((x: any) => x.reports);

            if (this.highConsumption_Reports.length > 0) {
              this.hidePreviouseHighConsumption_Reports_availableBtn = false;
              this.isHighConsumption_Reports_DownloadignInprogress =
                this.highConsumption_Reports.some(
                  (x: any) => x.isReportGenerating,
                );
              this.isHighConsumption_Reports_DownloadedLinkAvailable =
                this.highConsumption_Reports.some(
                  (x: any) => !x.isReportGenerating,
                );
              this.highConsumption_Reports_ReportfileUrl =
                this.highConsumption_Reports.find(
                  (x: any) => !x.isReportGenerating,
                );

              if (
                (type == 'download' || type == 'getStatus') &&
                !this.isHighConsumption_Reports_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Completed',
                  'Please Click Generated Report to get excel file',
                  SweetAlertIcon.INFO,
                );
              } else if (
                (type == 'getStatus' || type == 'download') &&
                this.isHighConsumption_Reports_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation In Progress',
                  'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
                  SweetAlertIcon.INFO,
                );
              }
            } else {
              this.hidePreviouseHighConsumption_Reports_availableBtn = true;
            }
            this.loaderService.setLoading(false);
          }
        },
      });
  }

  getLatestScheduleBillingReportStatus(type: string) {
    this.reportService
      .getLatestReportStatusService(this.userId, 'ScheduleBilling-Report')
      .subscribe({
        next: (response: any) => {
          if (response && response?.statusCode == 200) {
            console.log(response);
            this.ScheduleBilling_Reports = response?.data
              .filter((x: any) => x.reportName === 'ScheduleBilling-Report')
              .flatMap((x: any) => x.reports);

            if (this.ScheduleBilling_Reports.length > 0) {
              this.hidePreviouseScheduleBilling_Reports_availableBtn = false;
              this.isScheduleBilling_Reports_DownloadignInprogress =
                this.ScheduleBilling_Reports.some(
                  (x: any) => x.isReportGenerating,
                );
              this.isScheduleBilling_Reports_DownloadedLinkAvailable =
                this.ScheduleBilling_Reports.some(
                  (x: any) => !x.isReportGenerating,
                );
              console.log(
                this.isScheduleBilling_Reports_DownloadedLinkAvailable,
              );
              this.ScheduleBilling_Reports_ReportfileUrl =
                this.ScheduleBilling_Reports.find(
                  (x: any) => !x.isReportGenerating,
                );

              if (
                (type == 'download' || type == 'getStatus') &&
                !this.isScheduleBilling_Reports_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Completed',
                  'Please Click Generated Report to get excel file',
                  SweetAlertIcon.INFO,
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } else if (
                (type == 'getStatus' || type == 'download') &&
                this.isScheduleBilling_Reports_DownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation In Progress',
                  'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
                  SweetAlertIcon.INFO,
                );
              }
            } else {
              this.hidePreviouseScheduleBilling_Reports_availableBtn = true;
            }
            this.loaderService.setLoading(false);
          }
        },
      });
  }

  exportDailyConsumptionReport() {
    this.dailyutilityValidationMessage = ''; // Resetting utility validation message
    this.dailydateRangeValidationMessage = ''; // Resetting date range validation message

    let isValid = true;

    // Validate selected utilities
    if (
      !this.dailyconsumption_selectedUtility ||
      this.dailyconsumption_selectedUtility.length === 0
    ) {
      this.dailyutilityValidationMessage =
        'Please select at least one utility.';
      isValid = false;
    }

    // Validate selected date range
    if (this.dailyconsumptionDateRange.length != 2) {
      this.dailydateRangeValidationMessage = 'Please select a date range.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);

      const fromDate = new Date(
        this.dailyconsumptionDateRange[0].getTime() -
          this.dailyconsumptionDateRange[0].getTimezoneOffset() * 60000,
      );
      const toDate = new Date(
        this.dailyconsumptionDateRange[1].getTime() -
          this.dailyconsumptionDateRange[1].getTimezoneOffset() * 60000,
      );

      let payload = {
        fromDate: fromDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        toDate: toDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        utilityMasterId:
          this.dailyconsumption_selectedUtility &&
          this.dailyconsumption_selectedUtility.length > 0
            ? this.dailyconsumption_selectedUtility[0] === 'all'
              ? null
              : this.dailyconsumption_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
        residentialUnitId:
          this.dailyConsumption_selectedFlatNumber &&
          this.dailyConsumption_selectedFlatNumber.length > 0
            ? this.dailyConsumption_selectedFlatNumber[0] === 'all'
              ? null
              : this.dailyConsumption_selectedFlatNumber
            : null,
      };
      this.reportService.exportReport(payload, 'daily Consumption');
    }
  }

  exportMonthWiseWalletBalnceReports() {
    this.monthValidationMessage = ''; // Resetting month validation message
    let isValid = true;
    //  console.log(this.selectedMonthsForWalletBalanceReport)
    // Validate selected month
    if (this.selectedMonthsForWalletBalanceReport.length == 0) {
      this.monthValidationMessage = 'Please select a month.';
      isValid = false;
      return;
    }

    if (isValid) {
      this.loaderService.setLoading(true);

      const payload = {
        month: this.selectedMonth,
        months:
          this.selectedMonthsForWalletBalanceReport &&
          this.selectedMonthsForWalletBalanceReport.length > 0
            ? this.selectedMonthsForWalletBalanceReport[0] === 'all'
              ? null
              : this.selectedMonthsForWalletBalanceReport
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
      };
      this.reportService.exportReport(payload, 'monthwiseBalance');
    }
  }
  exportMeterMappingReports() {
    let isValid = true;

    // Validate selected utilities
    if (
      !this.meterMapping_selectedUtility ||
      this.meterMapping_selectedUtility.length === 0
    ) {
      this.meterMappingvaliadationMessage =
        'Please select at least one utility.';
      isValid = false;
    }

    if (
      !this.selecteMappingUtilityProject ||
      this.selecteMappingUtilityProject.length === 0
    ) {
      console.log(this.selecteMappingUtilityProject.length);
      this.MeterMappingProjectValidationMessage =
        'Please select at least one Project.';
      isValid = false;
    }
    console.log(this.meterMapping_selectedUtility);
    if (isValid) {
      this.loaderService.setLoading(true);
      let payload = {
        utilities:
          this.meterMapping_selectedUtility &&
          this.meterMapping_selectedUtility.length > 0
            ? this.meterMapping_selectedUtility[0] === 'all'
              ? null
              : this.meterMapping_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectIds:
          this.selecteMappingUtilityProject &&
          this.selecteMappingUtilityProject.length > 0
            ? this.selecteMappingUtilityProject[0] === 'all'
              ? null
              : this.selecteMappingUtilityProject
            : null, // Handling cases where selectedUtility is empty or "all"
      };
      console.log(payload);
      this.reportService.exportReport(payload, 'MeterMapping Report');
    }
  }

  exportBillWiseConsumptionReports() {
    this.utilityValidationMessage = ''; // Resetting utility validation message
    this.monthValidationMessage = ''; // Resetting month validation message
    this.flatNumberValidationMessage = ''; // Resetting flat number validation message

    let isValid = true;

    // Validate selected utilities
    if (
      !this.billwise_selectedUtility ||
      this.billwise_selectedUtility.length === 0
    ) {
      this.utilityValidationMessage = 'Please select at least one utility.';
      isValid = false;
    }

    // Validate selected month
    if (!this.selectedMonth) {
      this.monthValidationMessage = 'Please select a month.';
      isValid = false;
    }

    // Validate selected flat numbers
    if (
      !this.billwise_selectedFlatNumber ||
      this.billwise_selectedFlatNumber.length === 0
    ) {
      this.flatNumberValidationMessage =
        'Please select at least one flat number.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);

      const payload = {
        month: this.selectedMonth,
        utilityMasterId:
          this.billwise_selectedUtility &&
          this.billwise_selectedUtility.length > 0
            ? this.billwise_selectedUtility[0] === 'all'
              ? null
              : this.billwise_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
        residentialUnitId:
          this.billwise_selectedFlatNumber &&
          this.billwise_selectedFlatNumber.length > 0
            ? this.billwise_selectedFlatNumber[0] === 'all'
              ? null
              : this.billwise_selectedFlatNumber
            : null,
      };

      // this.reportService.exportReport(payload, 'postpaid');
      this.reportService.exportReport(
        payload,
        this.billingType === 'Prepaid'
          ? 'Statement Consumption Report'
          : 'Bill_Wise_Consumption_Reports',
      );
    }
  }

  exportDeviceCommunicationReports() {
    this.utilityValidationMessage = ''; // Resetting utility validation message
    this.dateRangeValidationMessage = ''; // Resetting month validation message
    this.flatNumberValidationMessage = ''; // Resetting flat number validation message

    let isValid = true;

    // Validate selected utilities
    if (
      !this.deviceCommunication_selectedUtility ||
      this.deviceCommunication_selectedUtility.length === 0
    ) {
      this.utilityValidationMessage = 'Please select at least one utility.';
      isValid = false;
    }

    if (!this.selectActivationStatus) {
      this.selectActivationStatusValidationMessage = 'Please select Active.';
      isValid = false;
    } else {
      this.selectActivationStatusValidationMessage = '';
    }

    // Validate selected month
    /*  if (!this.deviceCommunicationDateRange || this.deviceCommunicationDateRange.length == 0) {
       this.dateRangeValidationMessage = 'Please select a date range.';
       isValid = false;
     } */

    // Validate selected flat numbers
    if (
      !this.deviceCommunication_selectedFlatNumber ||
      this.deviceCommunication_selectedFlatNumber.length === 0
    ) {
      this.flatNumberValidationMessage =
        'Please select at least one flat number.';
      isValid = false;
    }

    if (
      !this.deviceCommunicationDateRange ||
      this.deviceCommunicationDateRange.length != 2
    ) {
      this.DeviceCommunicationdateRangeValidationMessage =
        'Please select Date Range.';
      isValid = false;
    } else {
      this.DeviceCommunicationdateRangeValidationMessage = '';
    }

    if (isValid) {
      this.loaderService.setLoading(true);

      let fromDate = null;
      let toDate = null;

      // Check if deviceCommunicationDateRange is available and set dates

      if (this.deviceCommunicationDateRange.length > 0) {
        fromDate = new Date(
          this.deviceCommunicationDateRange[0].getTime() -
            this.deviceCommunicationDateRange[0].getTimezoneOffset() * 60000,
        );
        toDate = new Date(
          this.deviceCommunicationDateRange[1].getTime() -
            this.deviceCommunicationDateRange[1].getTimezoneOffset() * 60000,
        );
      }
      // If fromDate or toDate is not set, use the current date or another default value
      /*  if (!fromDate) {
         fromDate = null; // Default to current date or handle as needed
       }
       if (!toDate) {
         toDate = null; // Default to current date or handle as needed
       } */
      let payload = {
        fromDate:
          fromDate !== null ? fromDate?.toISOString().slice(0, 10) : null, // Extracting "YYYY-MM-DD"
        toDate: toDate !== null ? toDate?.toISOString().slice(0, 10) : null, // Extracting "YYYY-MM-DD"
        utilityMasterId:
          this.deviceCommunication_selectedUtility &&
          this.deviceCommunication_selectedUtility.length > 0
            ? this.deviceCommunication_selectedUtility[0] === 'all'
              ? null
              : this.deviceCommunication_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
        residentialUnitId:
          this.deviceCommunication_selectedFlatNumber &&
          this.deviceCommunication_selectedFlatNumber.length > 0
            ? this.deviceCommunication_selectedFlatNumber[0] === 'all'
              ? null
              : this.deviceCommunication_selectedFlatNumber
            : null,
        active: this.selectActivationStatus,
        // "mcbStatus": this.selecteddeviceCommunicationMcb,
        // "valveStatus": this.selectedValve_Status,
        communicatingStatus: this.selectedCommnunicationStatus,
        userid: this.userId,
      };

      // this.reportService.exportReport(payload, 'DeviceCommunications');

      this.reportService
        .exportReportMeterReadings(payload, 'DeviceCommunications')
        .subscribe(
          (response: any) => {
            if (response.statusCode == 200) {
              this.getLatestDeviceCommunicationReportStatus('download');
              // console.log(response.message); // "Report downloaded successfully."
            } else {
              //  console.log(response.message); // "No Data Found." or any other message
            }
          },
          (error) => {
            console.error('Error while exporting report:', error);
          },
        );
    }
  }

  getLatestDeviceCommunicationReportStatus(type: string) {
    this.reportService
      .getLatestMeterReadingsReportStatusService(
        this.userId,
        this.projectId,
        'Device-Communication',
      )
      .subscribe({
        next: (response: any) => {
          if (response && response?.statusCode == 200) {
            console.log(response);
            this.deviceCommunicationReports = response?.data
              .filter((x: any) => x.reportName === 'Device-Communication')
              .flatMap((x: any) => x.reports);

            /*  const hasFailedStatus = this.deviceCommunicationReports.some(
              (item) => item.status === 'Failed'
            ); */

            if (this.deviceCommunicationReports.length > 0) {
              this.hidePreviouseDeviceCommunicationReportavailableBtn = false;
              this.isDeviceCommunicationDownloadignInprogress =
                this.deviceCommunicationReports.some(
                  (x: any) => x.isReportGenerating,
                );
              this.isDeviceCommunicationDownloadedLinkAvailable =
                this.deviceCommunicationReports.some(
                  (x: any) => !x.isReportGenerating,
                );
              this.deviceCommunicationfileUrl =
                this.deviceCommunicationReports.find(
                  (x: any) => !x.isReportGenerating,
                );

              if (
                (type == 'download' || type == 'getStatus') &&
                !this.isDeviceCommunicationDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Completed',
                  'Please Click Generated Report to get excel file',
                  SweetAlertIcon.INFO,
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } else if (
                /*  else if (
                hasFailedStatus &&
                !this.isDeviceCommunicationDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation Failed',
                  'Please regenerate the report to download the Excel file',
                  SweetAlertIcon.ERROR
                );
                // this.sharedService.downloadUtilityFiles(this.meterfileUrl.name, 'meterreading.xlsx');
              } */
                (type == 'getStatus' || type == 'download') &&
                this.isDeviceCommunicationDownloadignInprogress
              ) {
                this.sharedService.showMessageDialog(
                  'Report Generation In Progress',
                  'The requested report is currently being generated. Once completed, you can download it by clicking on the <strong>"Generated Report"',
                  SweetAlertIcon.INFO,
                );
              }
            } else {
              this.hidePreviouseDeviceCommunicationReportavailableBtn = true;
            }
            this.loaderService.setLoading(false);
          }
        },
      });
  }

  exportMeterReadingReports() {
    this.utilityValidationMessage = ''; // Resetting utility validation message
    this.meterreadingdateRangeValidationMessage = ''; // Resetting month validation message
    this.flatNumberValidationMessage = ''; // Resetting flat number validation message

    let isValid = true;

    // Validate selected utilities
    if (
      !this.meterReading_selectedUtility ||
      this.meterReading_selectedUtility.length === 0
    ) {
      this.utilityValidationMessage = 'Please select at least one utility.';
      isValid = false;
    }

    // Validate selected month
    if (!this.meterReadingDateRange || this.meterReadingDateRange.length != 2) {
      this.meterreadingdateRangeValidationMessage =
        'Please select a date range.';
      isValid = false;
    } else {
      const today = this.stripTime(new Date());
      const minDate = new Date(today.getFullYear(), today.getMonth() - 6, 1);
      minDate.setDate(
        Math.min(
          today.getDate(),
          new Date(minDate.getFullYear(), minDate.getMonth() + 1, 0).getDate(),
        ),
      );
      const startDate = this.stripTime(this.meterReadingDateRange[0]);
      const endDate = this.stripTime(this.meterReadingDateRange[1]);

      if (startDate < minDate || endDate > today) {
        this.meterreadingdateRangeValidationMessage =
          'Select dates within the last 6 months.';
        isValid = false;
      } else if (this.addDays(startDate, 31) < endDate) {
        this.meterreadingdateRangeValidationMessage =
          'Select a date range of no more than 1 month.';
        isValid = false;
      }
    }

    // Validate selected flat numbers
    // if (!this.meterReading_selectedFlatNumber || this.meterReading_selectedFlatNumber.length === 0) {
    //   this.flatNumberValidationMessage = 'Please select at least one flat number.';
    //   isValid = false;
    // }

    if (isValid) {
      this.loaderService.setLoading(true);
      const fromDate = new Date(
        this.meterReadingDateRange[0].getTime() -
          this.meterReadingDateRange[0].getTimezoneOffset() * 60000,
      );
      const toDate = new Date(
        this.meterReadingDateRange[1].getTime() -
          this.meterReadingDateRange[1].getTimezoneOffset() * 60000,
      );

      let payload = {
        fromDate: fromDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        toDate: toDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        utilityMasterId:
          this.meterReading_selectedUtility &&
          this.meterReading_selectedUtility.length > 0
            ? this.meterReading_selectedUtility[0] === 'all'
              ? null
              : this.meterReading_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
        residentialUnitId:
          this.meterReading_selectedFlatNumber &&
          this.meterReading_selectedFlatNumber.length > 0
            ? this.meterReading_selectedFlatNumber[0] === 'all'
              ? null
              : this.meterReading_selectedFlatNumber
            : null,
        userid: this.userId,
        // "valveStatus": this.selectedValve_Status,
      };
      // this.reportService.exportReport(payload, 'MeterReadings')
      // Assuming you're calling the exportReport method somewhere in your component
      this.reportService
        .exportReportMeterReadings(payload, 'MeterReadings')
        .subscribe(
          (response: any) => {
            if (response.statusCode == 200) {
              this.getLatestMeterReadingsReportStatus('download');
              // console.log(response.message); // "Report downloaded successfully."
            } else {
              //  console.log(response.message); // "No Data Found." or any other message
            }
          },
          (error) => {
            console.error('Error while exporting report:', error);
          },
        );
    }
  }

  exportBillGenerationReports() {
    this.utilityValidationMessage = ''; // Resetting utility validation message
    this.billgendateRangeValidationMessage = ''; // Resetting month validation message
    this.flatNumberValidationMessage = ''; // Resetting flat number validation message

    let isValid = true;

    // Validate selected utilities
    if (
      !this.billgeneration_selectedUtility ||
      this.billgeneration_selectedUtility.length === 0
    ) {
      this.utilityValidationMessage = 'Please select at least one utility.';
      isValid = false;
    }

    // Validate selected month
    if (
      !this.billGenerationDateRange ||
      this.billGenerationDateRange.length != 2
    ) {
      this.billgendateRangeValidationMessage = 'Please select a date range.';
      isValid = false;
    }

    // Validate selected flat numbers
    if (
      !this.billGeneration_selectedFlatNumber ||
      this.billGeneration_selectedFlatNumber.length === 0
    ) {
      this.flatNumberValidationMessage =
        'Please select at least one flat number.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);

      // Adjust dates to handle timezone offset
      const fromDate = new Date(
        this.billGenerationDateRange[0].getTime() -
          this.billGenerationDateRange[0].getTimezoneOffset() * 60000,
      );
      const toDate = new Date(
        this.billGenerationDateRange[1].getTime() -
          this.billGenerationDateRange[1].getTimezoneOffset() * 60000,
      );

      let payload = {
        fromDate: fromDate.toISOString().slice(0, 10), // "YYYY-MM-DD" format without timezone shift
        toDate: toDate.toISOString().slice(0, 10), // "YYYY-MM-DD" format without timezone shift
        utilityMasterId:
          this.billgeneration_selectedUtility &&
          this.billgeneration_selectedUtility.length > 0
            ? this.billgeneration_selectedUtility[0] === 'all'
              ? null
              : this.billgeneration_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        projectId: this.projectId,
        residentialUnitId:
          this.billGeneration_selectedFlatNumber &&
          this.billGeneration_selectedFlatNumber.length > 0
            ? this.billGeneration_selectedFlatNumber[0] === 'all'
              ? null
              : this.billGeneration_selectedFlatNumber
            : null,
        status: this.selectedValve_Status_MeterReadings,
      };
      this.reportService.exportReport(payload, 'BillGeneration');
    }
  }

  exportWalletBalanceReports() {
    this.utilityValidationMessage = ''; // Resetting utility validation message
    this.consymerWalletdateRangeValidationMessage = ''; // Resetting month validation message
    // this.flatNumberValidationMessage = ''; // Resetting flat number validation message

    let isValid = true;

    // Validate selected month
    if (
      !this.walletBalanceDateRange ||
      this.walletBalanceDateRange.length != 2
    ) {
      this.consymerWalletdateRangeValidationMessage =
        'Please select a date range.';
      isValid = false;
    }

    // Validate selected flat numbers
    if (
      !this.selected_walletbalance ||
      this.selected_walletbalance.length === 0
    ) {
      this.flatNumberValidationMessage =
        'Please select at least one Status Type.';
      isValid = false;
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      const fromDate = new Date(
        this.walletBalanceDateRange[0].getTime() -
          this.walletBalanceDateRange[0].getTimezoneOffset() * 60000,
      );
      const toDate = new Date(
        this.walletBalanceDateRange[1].getTime() -
          this.walletBalanceDateRange[1].getTimezoneOffset() * 60000,
      );

      let payload = {
        fromDate: fromDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        toDate: toDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        projectId: this.projectId,
        status:
          this.selected_walletbalance && this.selected_walletbalance.length > 0
            ? this.selected_walletbalance[0] === 'all'
              ? null
              : this.selected_walletbalance
            : null,
        residentialUnitId:
          this.wallet_selectedFlatNumber &&
          this.wallet_selectedFlatNumber.length > 0
            ? this.wallet_selectedFlatNumber[0] === 'all'
              ? null
              : this.wallet_selectedFlatNumber
            : null,
      };
      this.reportService.exportReport(payload, 'WalletBalance');
    }
  }
  validateDateRange(range: Date[]): boolean {
    if (!range || range.length !== 2) return true; // invalid selection

    const startDate = new Date(range[0]);
    const endDate = new Date(range[1]);

    // Add 3 months to start date
    const maxAllowedDate = new Date(startDate);
    maxAllowedDate.setMonth(maxAllowedDate.getMonth() + 3);

    // Check if end date exceeds 3 months
    if (endDate > maxAllowedDate) {
      // alert('Selecting a date range greater than 3 months is not allowed.');
      return false;
    }

    return true;
  }

  exportWalletHistoryReports() {
    this.utilityValidationMessage = ''; // Resetting utility validation message
    this.waleyHistorydateRangeValidationMessage = ''; // Resetting month validation message
    //this.flatNumberValidationMessage = ''; // Resetting flat number validation message
    this.walletreportFaltValiadtion = '';
    let isValid = true;

    // Validate selected month
    if (
      !this.walletHistoryDateRange ||
      this.walletHistoryDateRange.length != 2
    ) {
      this.waleyHistorydateRangeValidationMessage =
        'Please select a date range.';
      isValid = false;
    }

    // Validate selected flat numbers
    if (
      !this.walletHistory_selectedUtility ||
      this.walletHistory_selectedUtility.length === 0
    ) {
      this.utilityValidationMessage = 'Please select at least one utility.';
      isValid = false;
    }

    if (!this.wallet_FlatNumber || this.wallet_FlatNumber.length == 0) {
      this.walletreportFaltValiadtion = 'Please select flat number.';
      isValid = false;
    }

    //walletHistoryDateRange
    console.log(this.walletHistoryDateRange);
    console.log(this.validateDateRange(this.walletHistoryDateRange));

    if (!this.validateDateRange(this.walletHistoryDateRange)) {
      this.sharedService.showMessageDialog(
        'Wallet History Reports',
        'Selecting a date range more than 3 months is not allowed.',
        SweetAlertIcon.INFO,
      );

      return;
    }

    if (isValid) {
      this.loaderService.setLoading(true);
      const fromDate = new Date(
        this.walletHistoryDateRange[0].getTime() -
          this.walletHistoryDateRange[0].getTimezoneOffset() * 60000,
      );
      const toDate = new Date(
        this.walletHistoryDateRange[1].getTime() -
          this.walletHistoryDateRange[1].getTimezoneOffset() * 60000,
      );

      let payload = {
        residentialUnitId:
          this.wallet_FlatNumber && this.wallet_FlatNumber.length > 0
            ? this.wallet_FlatNumber[0] === 'all'
              ? null
              : this.wallet_FlatNumber
            : null,
        ConsumerId:
          this.selected_Consumers && this.selected_Consumers.length > 0
            ? this.selected_Consumers[0] === 'all'
              ? null
              : this.selected_Consumers
            : null,
        fromDate: fromDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        toDate: toDate.toISOString().slice(0, 10), // Extracting "YYYY-MM-DD"
        projectId: this.projectId,
        utilityMasterId:
          this.walletHistory_selectedUtility &&
          this.walletHistory_selectedUtility.length > 0
            ? this.walletHistory_selectedUtility[0] === 'all'
              ? null
              : this.walletHistory_selectedUtility
            : null, // Handling cases where selectedUtility is empty or "all"
        userid: this.userId,
      };
      this.reportService
        .exportReportMeterReadings(payload, 'WalletHistory')
        .subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.getLatestWalletHistoryReportStatus('download');
              // console.log(response.message); // "Report downloaded successfully."
            } else {
              //  console.log(response.message); // "No Data Found." or any other message
            }
          },
          error: (err) => {
            console.error('Error while exporting report:', err);
          },
        });
      // this.reportService.exportReport(payload, 'WalletHistory');
    }
  }

  onSelectAllUtility() {
    this.isUtilityChecked = !this.isUtilityChecked;
    this.selectedUtility = this.isUtilityChecked
      ? this.configData?.utilities.slice()
      : [];
  }
  isUtilityItemSelected(item: any) {
    const isSelected = this.selectedUtility.some((x: any) => x.id === item.id);
    this.isUtilityChecked =
      this.utilityList.length === this.selectedUtility.length;

    return isSelected;
  }

  utilityValueChange(value: any): void {
    if (value.length > 0) {
      let selectAlldata = value.filter((x: any) => {
        return x.id == 'selectAll';
      });
      if (selectAlldata.length > 0) {
        this.selectedUtility = this.configData?.utilities;
      }
    } else {
      this.selectedUtility = [];
      this.isUtilityChecked = false;
    }
  }
  get isUtilityIndet() {
    return (
      this.selectedUtility.length !== 0 &&
      this.selectedUtility.length !== this.configData.utilities.length
    );
  }

  get isBatteryIndet() {
    return (
      this.selectedBatteryLevel.length !== 0 &&
      this.selectedBatteryLevel.length !== this.batteryLevel.length
    );
  }
  // onSelectBatteryLevelAll() {
  //   this.isBatteryChecked = !this.isBatteryChecked;
  //   this.selectedBatteryLevel = this.isBatteryChecked
  //     ? this.batteryLevel.slice()
  //     : [];
  // }

  // isBatteryItemSelected(item: any) {
  //   const isSelected = this.selectedBatteryLevel.some(
  //     (x: any) => x.id === item.id
  //   );
  //   this.isBatteryChecked =
  //     this.batteryLevel.length === this.selectedBatteryLevel.length;
  //   return isSelected;
  // }

  public onFilterProjectsChange(searchTerm: any): void {
    const contains = (value: string) => (item: { name: string; id: number }) =>
      item.name?.toLowerCase().includes(value?.toLowerCase());

    this.projectsList = this.configData?.utilities.filter(contains(searchTerm));
  }

  public onFilterUtilitiesChange(searchTerm: any): void {
    console.log(searchTerm);
    console.log(this.consumption_selectedUtility);
    // Convert searchTerm to a string, default to an empty string if it's not valid
    const term = typeof searchTerm === 'string' ? searchTerm : '';
    const contains = (value: string) => (item: { name: string; id: string }) =>
      item.name?.toLowerCase().includes(value?.toLowerCase());

    // Assuming configData.utilities is an array of utility objects

    this.utilityList = this.configData?.utilities.filter(contains(term)) || [];
    console.log(this.utilityList);
  }

  public onFilterBatteryLevelUtilitiesChange(searchTerm: any): void {
    // Convert searchTerm to a string, default to an empty string if it's not valid
    const term = typeof searchTerm === 'string' ? searchTerm : '';
    const contains = (value: string) => (item: { name: string; id: string }) =>
      item.name.toLowerCase().includes(value.toLowerCase());

    // Assuming configData.utilities is an array of utility objects

    this.BatteryLevelutilityList =
      this.BatteryLevelutilityListDup.filter(contains(term)) || [];
  }

  public onFilteWalletChange(searchTerm: any): void {
    console.log(this.selected_walletbalance);
    console.log(searchTerm);
    // Convert searchTerm to a string, default to an empty string if it's not valid
    const term = typeof searchTerm === 'string' ? searchTerm : '';
    const contains = (value: string) => (item: { name: string; id: string }) =>
      item.name.toLowerCase().includes(value.toLowerCase());

    // Assuming configData.utilities is an array of utility objects

    this.WalletBalance_Status =
      WalletBalanceStatus.filter(contains(term)) || [];
    console.log(this.WalletBalance_Status);
  }

  public onFilterFlatsChange(searchTerm: any): void {
    // Convert searchTerm to a string, default to an empty string if it's not valid
    const term = typeof searchTerm === 'string' ? searchTerm : '';
    const contains = (value: string) => (item: { name: string; id: string }) =>
      item.name.toLowerCase().includes(value.toLowerCase());

    // Assuming configData.utilities is an array of utility objects

    this.flatnumbersList = this.flatnumbersListDup.filter(contains(term)) || [];
  }

  public onFilterWalletFlatsChange(searchTerm: any): void {
    // Convert searchTerm to a string, default to an empty string if it's not valid
    const term = typeof searchTerm === 'string' ? searchTerm : '';
    const contains = (value: string) => (item: { name: string; id: string }) =>
      item.name.toLowerCase().includes(value.toLowerCase());

    // Assuming configData.utilities is an array of utility objects

    this.flatnumbersList =
      this.walletBanlanceFalttemList.filter(contains(term)) || [];
  }

  public onFilterWalletConsumersChange(searchTerm: any): void {
    // Convert searchTerm to a string, default to an empty string if it's not valid
    const term = typeof searchTerm === 'string' ? searchTerm : '';
    const contains = (value: string) => (item: { name: string; id: string }) =>
      item.name.toLowerCase().includes(value.toLowerCase());

    // Assuming configData.utilities is an array of utility objects

    this.consumersIdsList =
      this.walletBanlanceFalttemList.filter(contains(term)) || [];
  }

  // public onFilterMonthsChange(searchTerm: string): void {
  //   const contains = (value: string) => (item: { name: string; id: string }) =>
  //     item.name.toLowerCase().includes(value.toLowerCase());

  //   this.monthsList = Months.filter(contains(searchTerm));
  // }

  public onFilterMonthsChange(searchTerm: string | undefined | null): void {
    // If searchTerm is empty or null, reset the list to the full list
    if (!searchTerm) {
      this.monthsList = [...this.dupMonthsList]; // Restore the full list
      return;
    }

    console.log('Filtered Months:', this.monthsList);
  }

  public onSelectUtility(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selectedUtility.includes('all')) {
        this.selectedUtility = this.selectedUtility.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (this.selectedUtility.length === totalUtilityCount - 1) {
          this.selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onBatteryLevelSelectUtility(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selectedUtility.includes('all')) {
        this.selectedUtility = this.selectedUtility.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.BatteryLevelutilityListDup.length || 0;
        if (this.selectedUtility.length === totalUtilityCount - 1) {
          this.selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInConsumption(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.consumption_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.consumption_selectedUtility.includes('all')) {
        this.consumption_selectedUtility =
          this.consumption_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (this.consumption_selectedUtility.length === totalUtilityCount - 1) {
          this.consumption_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInDailyConsumption(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.dailyconsumption_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.dailyconsumption_selectedUtility.includes('all')) {
        this.dailyconsumption_selectedUtility =
          this.dailyconsumption_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.dailyconsumption_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.dailyconsumption_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectWalletType(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selected_walletbalance = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selected_walletbalance.includes('all')) {
        this.selected_walletbalance = this.selected_walletbalance.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalstatusCount = this.WalletBalance_Status.length || 0;
        if (this.selected_walletbalance.length === totalstatusCount - 1) {
          this.selected_walletbalance = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInBillWiseConsumption(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.billwise_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.billwise_selectedUtility.includes('all')) {
        this.billwise_selectedUtility = this.billwise_selectedUtility.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (this.billwise_selectedUtility.length === totalUtilityCount - 1) {
          this.billwise_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInDeviceCommunication(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.deviceCommunication_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.deviceCommunication_selectedUtility.includes('all')) {
        this.deviceCommunication_selectedUtility =
          this.deviceCommunication_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.deviceCommunication_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.deviceCommunication_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInMeterReading(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.meterReading_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.meterReading_selectedUtility.includes('all')) {
        this.meterReading_selectedUtility =
          this.meterReading_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.meterReading_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.meterReading_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInBillGenerationMeterReading(
    selectedItems: string[],
  ): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.billgeneration_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.billgeneration_selectedUtility.includes('all')) {
        this.billgeneration_selectedUtility =
          this.billgeneration_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.billgeneration_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.billgeneration_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInWalletHistoryReport(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.walletHistory_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.walletHistory_selectedUtility.includes('all')) {
        this.walletHistory_selectedUtility =
          this.walletHistory_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.walletHistory_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.walletHistory_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInMeterMapping(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.meterMapping_selectedUtility = ['all'];
    } else {
      if (this.meterMapping_selectedUtility.includes('all')) {
        this.meterMapping_selectedUtility =
          this.meterMapping_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.meterMapping_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.meterMapping_selectedUtility = ['all'];
        }
      }
    }
  }

  public onSelectUtilityInWalletHistory(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.walletHistory_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.walletHistory_selectedUtility.includes('all')) {
        this.walletHistory_selectedUtility =
          this.walletHistory_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.walletHistory_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.walletHistory_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectUtilityInBillGeneration(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.billgeneration_selectedUtility = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.billgeneration_selectedUtility.includes('all')) {
        this.billgeneration_selectedUtility =
          this.billgeneration_selectedUtility.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData?.utilities.length || 0;
        if (
          this.billgeneration_selectedUtility.length ===
          totalUtilityCount - 1
        ) {
          this.billgeneration_selectedUtility = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectFlatsInBillWiseConsumption(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.billwise_selectedFlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.billwise_selectedFlatNumber.includes('all')) {
        this.billwise_selectedFlatNumber =
          this.billwise_selectedFlatNumber.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.flatnumbersListDup.length || 0;
        if (this.billwise_selectedFlatNumber.length === totalUtilityCount - 1) {
          this.billwise_selectedFlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectMonthsForWalletBalanceReports(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selectedMonthsForWalletBalanceReport = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selectedMonthsForWalletBalanceReport.includes('all')) {
        this.selectedMonthsForWalletBalanceReport =
          this.selectedMonthsForWalletBalanceReport.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.dupMonthsListWithAll.length || 0;
        if (
          this.selectedMonthsForWalletBalanceReport.length ===
          totalUtilityCount - 1
        ) {
          this.selectedMonthsForWalletBalanceReport = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectFlatsInDeviceCommunication(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.deviceCommunication_selectedFlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.deviceCommunication_selectedFlatNumber.includes('all')) {
        this.deviceCommunication_selectedFlatNumber =
          this.deviceCommunication_selectedFlatNumber.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.flatnumbersListDup.length || 0;
        if (
          this.deviceCommunication_selectedFlatNumber.length ===
          totalUtilityCount - 1
        ) {
          this.deviceCommunication_selectedFlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectFlatsInMeterReadings(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.meterReading_selectedFlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.meterReading_selectedFlatNumber.includes('all')) {
        this.meterReading_selectedFlatNumber =
          this.meterReading_selectedFlatNumber.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.flatnumbersListDup.length || 0;
        if (
          this.meterReading_selectedFlatNumber.length ===
          totalUtilityCount - 1
        ) {
          this.meterReading_selectedFlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectFlatsInBillGeneration(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.billGeneration_selectedFlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.billGeneration_selectedFlatNumber.includes('all')) {
        this.billGeneration_selectedFlatNumber =
          this.billGeneration_selectedFlatNumber.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.flatnumbersListDup.length || 0;
        if (
          this.billGeneration_selectedFlatNumber.length ===
          totalUtilityCount - 1
        ) {
          this.billGeneration_selectedFlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectFlatsIndailyConsumption(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.dailyConsumption_selectedFlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.dailyConsumption_selectedFlatNumber.includes('all')) {
        this.dailyConsumption_selectedFlatNumber =
          this.dailyConsumption_selectedFlatNumber.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.flatnumbersListDup.length || 0;
        if (
          this.dailyConsumption_selectedFlatNumber.length ===
          totalUtilityCount - 1
        ) {
          this.dailyConsumption_selectedFlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }
  public onSelectFlatsInConsumption(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.Consumption_selectedFlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.Consumption_selectedFlatNumber.includes('all')) {
        this.Consumption_selectedFlatNumber =
          this.Consumption_selectedFlatNumber.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.flatnumbersListDup.length || 0;
        if (
          this.Consumption_selectedFlatNumber.length ===
          totalUtilityCount - 1
        ) {
          this.Consumption_selectedFlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectFlatsInWalletBalance(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.wallet_selectedFlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.wallet_selectedFlatNumber.includes('all')) {
        this.wallet_selectedFlatNumber = this.wallet_selectedFlatNumber.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.walletBanlanceFalttemList.length || 0;
        if (this.wallet_selectedFlatNumber.length === totalUtilityCount - 1) {
          this.wallet_selectedFlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  public onSelectFlatsInWalletHistory(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];
    if (selectedItems) {
      this.flatNumberValidationMessage = '';
    }

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.wallet_FlatNumber = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.wallet_FlatNumber.includes('all')) {
        this.wallet_FlatNumber = this.wallet_FlatNumber.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.walletBanlanceFalttemList.length || 0;
        if (this.wallet_FlatNumber.length === totalUtilityCount - 1) {
          this.wallet_FlatNumber = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }
  public onSelectConsumersInWalletHistory(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];
    if (selectedItems) {
      this.consumervaliadationMessage = '';
    }

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selected_Consumers = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selected_Consumers.includes('all')) {
        this.selected_Consumers = this.selected_Consumers.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.walletBanlanceFalttemList.length || 0;
        if (this.selected_Consumers.length === totalUtilityCount - 1) {
          this.selected_Consumers = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
  }

  onSelectSettlmentProject(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    console.log(selectedItems);
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selectedSettlementProject = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selectedSettlementProject.includes('all')) {
        this.selectedSettlementProject = this.selectedSettlementProject.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData.projects.length || 0;
        if (this.selectedSettlementProject.length === totalUtilityCount - 1) {
          this.selectedSettlementProject = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
    this.updateSettlementMinDate();
  }

  onSelectScheduledBillingProject(selectedItems: string[]): void {
    console.log(selectedItems);
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.projectId === 'all')) {
      this.selectedScheduledBillingProject = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selectedScheduledBillingProject.includes('all')) {
        this.selectedScheduledBillingProject =
          this.selectedScheduledBillingProject.filter(
            (item: any) => item !== 'all',
          );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.Billing_ProjectsList.length || 0;
        if (
          this.selectedScheduledBillingProject.length ===
          totalUtilityCount - 1
        ) {
          this.selectedScheduledBillingProject = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
    }
    this.updateScheduledBillingMinDate();
  }

  onSelectONOFFStatusProject(selectedItems: string[]): void {
    console.log(this.selectedOnOffStatusProject);
    // Ensure selectedItems is an array
    console.log(selectedItems);
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selectedOnOffStatusProject = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.selectedOnOffStatusProject.includes('all')) {
        this.selectedOnOffStatusProject =
          this.selectedOnOffStatusProject.filter((item: any) => item !== 'all');
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData.projects.length || 0;
        if (this.selectedOnOffStatusProject.length === totalUtilityCount - 1) {
          this.selectedOnOffStatusProject = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
      console.log(this.selectedOnOffStatusProject);
    }
    this.updateOnOffMinDate();
  }

  onSelectPrepaidMeterOffStatusProject(selectedItems: string[]): void {
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    if (itemsArray.some((item: any) => item.projectId === 'all')) {
      this.selectedPrepaidMeterOffStatusProject = ['all'];
    } else {
      if (this.selectedPrepaidMeterOffStatusProject.includes('all')) {
        this.selectedPrepaidMeterOffStatusProject =
          this.selectedPrepaidMeterOffStatusProject.filter(
            (item: any) => item !== 'all',
          );
      } else {
        const totalProjectCount =
          this.prepaidMeterOffStatus_ProjectsList.length || 0;
        if (
          this.selectedPrepaidMeterOffStatusProject.length ===
          totalProjectCount - 1
        ) {
          this.selectedPrepaidMeterOffStatusProject = ['all'];
        }
      }
    }
    this.updatePrepaidMeterOffStatusMinDate();
  }

  onSelectGatewayStatusProject(selectedItems: string[]): void {
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selectedGatewayStatusProject = ['all'];
    } else {
      if (this.selectedGatewayStatusProject.includes('all')) {
        this.selectedGatewayStatusProject =
          this.selectedGatewayStatusProject.filter(
            (item: any) => item !== 'all',
          );
      } else {
        const totalProjectCount = this.configData.projects.length || 0;
        if (
          this.selectedGatewayStatusProject.length ===
          totalProjectCount - 1
        ) {
          this.selectedGatewayStatusProject = ['all'];
        }
      }
    }
  }

  onSelectProject(selectedItems: string[]): void {
    console.log(this.seletedUtilityProject);
    console.log(selectedItems);
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.seletedUtilityProject = ['all'];
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.seletedUtilityProject.includes('all')) {
        this.seletedUtilityProject = this.seletedUtilityProject.filter(
          (item: any) => item !== 'all',
        );
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.configData.projects.length || 0;
        if (this.seletedUtilityProject.length === totalUtilityCount - 1) {
          this.seletedUtilityProject = ['all']; // Select "All Utilities" if all individual utilities are selected
        }
      }
      console.log(this.seletedUtilityProject);
    }
  }

  onSelectMeterMappingProject(selectedItems: string[]): void {
    console.log(this.selecteMappingUtilityProject);
    console.log(selectedItems);

    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selecteMappingUtilityProject = ['all'];
    } else {
      if (this.selecteMappingUtilityProject.includes('all')) {
        this.selecteMappingUtilityProject =
          this.selecteMappingUtilityProject.filter(
            (item: any) => item !== 'all',
          );
      } else {
        const totalProjectCount = this.configData.projects.length || 0;
        if (this.selecteMappingUtilityProject.length === totalProjectCount - 1) {
          this.selecteMappingUtilityProject = ['all'];
        }
      }
      console.log(this.selecteMappingUtilityProject);
    }
  }

  onSelectHighConsumptionProject(selectedItems: string[]): void {
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.selectedHighConsumptionProject = ['all'];
    } else {
      if (this.selectedHighConsumptionProject.includes('all')) {
        this.selectedHighConsumptionProject =
          this.selectedHighConsumptionProject.filter(
            (item: any) => item !== 'all',
          );
      } else {
        const totalProjectCount = this.configData.projects.length || 0;
        if (
          this.selectedHighConsumptionProject.length ===
          totalProjectCount - 1
        ) {
          this.selectedHighConsumptionProject = ['all'];
        }
      }
    }
    this.updateHighConsumptionMinDate();
  }

  private parseProjectStartDate(project: any): Date | null {
    const raw =
      project?.startDate ??
      project?.projectStartDate?.startDate ??
      project?.projectStartDate ??
      project?.project_start_date ??
      project?.projectStart;
    if (!raw) {
      const key = project?.id ?? project?.projectId;
      if (key !== undefined && this.projectStartDateById.has(key)) {
        return this.projectStartDateById.get(key) ?? null;
      }
      return null;
    }
    const parsed = new Date(raw);
    return isNaN(parsed.getTime()) ? null : this.stripTime(parsed);
  }

  private getMinStartDateForSelection(
    selectedIds: any[],
    projectList: any[],
    idKey: 'id' | 'projectId',
  ): Date | null {
    if (!projectList || projectList.length === 0) {
      return null;
    }
    const ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
    const filteredIds = ids.filter((id: any) => id !== 'all');
    const list =
      filteredIds.length > 0
        ? projectList.filter((p: any) =>
            filteredIds.includes(p?.[idKey] ?? p?.id ?? p?.projectId),
          )
        : projectList.filter(
            (p: any) => (p?.[idKey] ?? p?.id ?? p?.projectId) !== 'all',
          );

    const dates = list
      .map((p: any) => this.parseProjectStartDate(p))
      .filter((d: Date | null) => !!d) as Date[];
    if (dates.length === 0) {
      return null;
    }
    return dates.reduce((min, d) => (d < min ? d : min), dates[0]);
  }

  private updateRangeMinDate(
    rangeKey: string,
    baseKey: string,
    minDate: Date | null,
  ) {
    if (!minDate) {
      return;
    }
    const baseConfig = (this as any)[baseKey] as Partial<BsDatepickerConfig>;
    (this as any)[baseKey] = {
      ...(baseConfig ?? {}),
      minDate,
    };
    const config = this.getRangeConfig(rangeKey, baseKey);
    this.rangeConfigs[rangeKey] = {
      ...config,
      minDate,
    };

    const currentRange = (this as any)[rangeKey] as
      | (Date | undefined)[]
      | undefined;
    if (Array.isArray(currentRange) && currentRange[0]) {
      const start = this.stripTime(currentRange[0]);
      if (start < minDate) {
        (this as any)[rangeKey] = [];
        this.setRangeMaxDate(rangeKey, this.defaultRangeMaxDate ?? undefined);
      }
    }
  }

  private updateSettlementMinDate() {
    const minDate = this.getMinStartDateForSelection(
      this.selectedSettlementProject,
      this.projectsList,
      'id',
    );
    this.updateRangeMinDate('settlemetDateRange', 'datePickerConfig', minDate);
  }

  private updateScheduledBillingMinDate() {
    const minDate = this.getMinStartDateForSelection(
      this.selectedScheduledBillingProject,
      this.Billing_ProjectsList,
      'projectId',
    );
    this.updateRangeMinDate(
      'selectedScheduledBillingDateRange',
      'datePickerscheduledBilling',
      minDate,
    );
  }

  private updateOnOffMinDate() {
    const minDate = this.getMinStartDateForSelection(
      this.selectedOnOffStatusProject,
      this.projectsList,
      'id',
    );
    this.updateRangeMinDate(
      'selectedOnOffStatusDateRange',
      'datePickeronoffStatus',
      minDate,
    );
  }

  private updatePrepaidMeterOffStatusMinDate() {
    const projectMinDate = this.getMinStartDateForSelection(
      this.selectedPrepaidMeterOffStatusProject,
      this.prepaidMeterOffStatus_ProjectsList,
      'projectId',
    );
    const last15DaysDate = this.addDays(this.stripTime(new Date()), -15);
    const minDate = projectMinDate
      ? projectMinDate > last15DaysDate
        ? projectMinDate
        : last15DaysDate
      : last15DaysDate;

    this.updateRangeMinDate(
      'selectedPrepaidMeterOffStatusDateRange',
      'datePickerPrepaidMeterOffStatus',
      minDate,
    );
  }

  private updatePrepaidMeterOffStatusProjectStartDates() {
    (this.prepaidMeterOffStatus_ProjectsList || []).forEach((item: any) => {
      const parsed = this.parseProjectStartDate(item);
      if (parsed) {
        if (item?.id !== undefined) {
          this.projectStartDateById.set(item.id, parsed);
        }
        if (item?.projectId !== undefined) {
          this.projectStartDateById.set(item.projectId, parsed);
        }
      }
    });
  }

  private updateHighConsumptionMinDate() {
    const minDate = this.getMinStartDateForSelection(
      this.selectedHighConsumptionProject,
      this.projectsList,
      'id',
    );
    this.updateRangeMinDate(
      'highConsumptionDateRange',
      'datePickerConfig',
      minDate,
    );
  }

  openCalendarsettlement() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.settlement');
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendarScheduled() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.Scheduled');
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendarONOFF() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.onOff');
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendarPrepaidMeterOffStatus() {
    const dateInput = document.querySelector(
      '.form-control.prepaidMeterOffStatus',
    );
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendarHighConsumption() {
    const dateInput = document.querySelector('.form-control.highConsumption');
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendar() {
    if (this.activationPicker) {
      this.activationPicker.show();
      return;
    }
    const dateInput = document.querySelector('.form-control.date');
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendarConsumption() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.dateconsumetion');
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendardailyConsumption() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.dailyconsumetion');
    dateInput?.dispatchEvent(new Event('click'));
  }
  openCalendarDeviceCommunication() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector(
      '.form-control.datedeviceCommunication',
    );
    dateInput?.dispatchEvent(new Event('click'));
  }
  openCalendarMeterReading() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.datemeterReading');
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendarBillGeneration() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector(
      '.form-control.datebillGeneration',
    );
    dateInput?.dispatchEvent(new Event('click'));
  }
  openCalendarWalletBalance() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector(
      '.form-control.datewalletBalanceReport',
    );
    dateInput?.dispatchEvent(new Event('click'));
  }

  openCalendarWalletHistory() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.datewalletHistory');
    dateInput?.dispatchEvent(new Event('click'));
  }

  formatDateRange(dateRange: (Date | null)[]): string {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const startDate = formatDate(dateRange[0], 'dd/MM/yyyy', 'en-US');
      const endDate = formatDate(dateRange[1], 'dd/MM/yyyy', 'en-US');
      return `${startDate} to ${endDate}`;
    }
    return ''; // Return empty string if the date range is not valid
  }

  clearDateSettlement() {
    this.clearRange('settlemetDateRange', 'datePickerConfig');
  }

  clearDateScheduledBilling() {
    this.clearRange(
      'selectedScheduledBillingDateRange',
      'datePickerscheduledBilling',
    );
  }

  clearDateOnOffStatusdate() {
    this.clearRange('selectedOnOffStatusDateRange', 'datePickeronoffStatus');
  }

  clearDatePrepaidMeterOffStatus() {
    this.clearRange(
      'selectedPrepaidMeterOffStatusDateRange',
      'datePickerPrepaidMeterOffStatus',
    );
  }

  clearHighConsumptionDate() {
    this.clearRange('highConsumptionDateRange', 'datePickerConfig');
  }
  clearDate() {
    this.clearRange('activationDateRange', 'activationDatePickerConfig');
    this.resetActivationDateLimits();
  }
  clearConsumptionDate() {
    this.clearRange('consumptionDateRange', 'adminDateRangePickerConfig');
  }
  cleardailyConsumptionDate() {
    this.clearRange('dailyconsumptionDateRange', 'datePickerConfig');
  }
  clearDeviceCommunicationDate() {
    this.clearRange(
      'deviceCommunicationDateRange',
      'deviceCommunicationdatePickerConfig',
    );
  }
  clearbillGenerationDate() {
    this.clearRange('billGenerationDateRange', 'billGenerationDatePickerConfig');
  }
  clearwalletBalanceDate() {
    this.clearRange('walletBalanceDateRange', 'Wallet_datePickerConfig');
  }

  clearwalletHistoryDate() {
    this.clearRange('walletHistoryDateRange', 'walletHistoryDatePickerConfig');
  }
  clearMeterReadingDate() {
    this.clearRange('meterReadingDateRange', 'meterReadingsReportDates');
  }
  clearBillWiseDate() {
    this.clearRange('billwiseDateRange', 'datePickerConfig');
  }

  onDateRangeSelected(event: any) {
    console.log(event);
    console.log(this.consumptionDateRange);
  }

  onGenericDateRangeChange(
    range: (Date | undefined)[] | undefined,
    rangeKey: string,
    baseKey: string,
  ) {
    if (
      this.role == this.listOfRoles.ADMIN ||
      this.role == this.listOfRoles.SUPERADMIN ||
      this.role == this.listOfRoles.SUPERUSER
    ) {
      return;
    }
    const config = this.getRangeConfig(rangeKey, baseKey);
    if (!config) {
      return;
    }

    if (!Array.isArray(range) || range.length === 0 || !range[0]) {
      const fallbackMax = this.defaultRangeMaxDate ?? config.maxDate;
      this.setRangeMaxDate(rangeKey, fallbackMax);
      this.rangeConfigs[rangeKey] = {
        ...config,
        maxDate: fallbackMax,
      };
      return;
    }

    const start = this.stripTime(range[0]);
    const maxDate = this.getRangeMaxForKey(rangeKey, start);
    this.setRangeMaxDate(rangeKey, maxDate);
    const datesEnabled = this.buildEnabledDates(start, maxDate);

    this.rangeConfigs[rangeKey] = {
      ...config,
      maxDate,
      datesEnabled,
    };

    if (range[1]) {
      const end = this.stripTime(range[1]);
      if (end > maxDate) {
        (this as any)[rangeKey] = [start, maxDate];
      }
    }
  }

  getDefaultRangeMaxDate(
    range: (Date | undefined)[] | undefined,
  ): Date | undefined {
    if (Array.isArray(range) && range[0]) {
      return this.calculateRangeMaxDate(this.stripTime(range[0]));
    }
    return this.defaultRangeMaxDate ?? undefined;
  }

  getActivationRangeMaxDate(
    range: (Date | undefined)[] | undefined,
  ): Date | undefined {
    if (Array.isArray(range) && range[0]) {
      return this.calculateRangeMaxDate(this.stripTime(range[0]));
    }
    return this.activationDefaultMaxDate ?? undefined;
  }

  getRangeMaxDate(
    rangeKey: string,
    useActivationDefault = false,
  ): Date | undefined {
    if (this.rangeMaxDates[rangeKey]) {
      return this.rangeMaxDates[rangeKey];
    }
    return useActivationDefault
      ? (this.activationDefaultMaxDate ?? undefined)
      : (this.defaultRangeMaxDate ?? undefined);
  }

  getRangeConfig(
    rangeKey: string,
    baseKey: string,
  ): Partial<BsDatepickerConfig> {
    if (!this.rangeConfigs[rangeKey]) {
      this.rangeConfigs[rangeKey] = { ...(this as any)[baseKey] };
    }
    return this.rangeConfigs[rangeKey];
  }

  getActivationConfig(): Partial<BsDatepickerConfig> {
    return this.activationDatePickerConfig ?? {};
  }

  private setRangeMaxDate(rangeKey: string, maxDate: Date | undefined) {
    this.rangeMaxDates[rangeKey] = maxDate;
  }

  private resetRangeMaxDate(rangeKey: string) {
    this.setRangeMaxDate(rangeKey, this.defaultRangeMaxDate ?? undefined);
  }

  private clearRange(rangeKey: string, baseKey: string) {
    (this as any)[rangeKey] = [];
    this.setRangeMaxDate(rangeKey, this.defaultRangeMaxDate ?? undefined);
    const baseConfig = (this as any)[baseKey] as Partial<BsDatepickerConfig>;
    this.rangeConfigs[rangeKey] = {
      ...(baseConfig ?? {}),
      value: [],
    };
  }

  private prepareRangeForReopen(rangeKey: string) {
    this.setRangeMaxDate(rangeKey, this.defaultRangeMaxDate ?? undefined);
    delete this.rangeConfigs[rangeKey];
    this.autoPreselectRanges.add(rangeKey);
    (this as any)[rangeKey] = [];
  }

  private buildEnabledDates(start: Date, end: Date): Date[] {
    const dates: Date[] = [];
    let cursor = this.stripTime(start);
    const last = this.stripTime(end);
    while (cursor <= last) {
      dates.push(new Date(cursor));
      cursor.setDate(cursor.getDate() + 1);
    }
    return dates;
  }

  private calculateRangeMaxDate(startDate: Date): Date {
    const maxByRange = this.addDays(startDate, 31);
    const cap = this.defaultRangeMaxDate ?? this.stripTime(new Date());
    return maxByRange > cap ? cap : maxByRange;
  }

  private calculateActivationMaxDate(startDate: Date): Date {
    const maxByRange = this.addDays(startDate, 31);
    const cap = this.activationDefaultMaxDate ?? this.stripTime(new Date());
    return maxByRange > cap ? cap : maxByRange;
  }

  private getRangeMaxForKey(rangeKey: string, startDate: Date): Date {
    return rangeKey === 'activationDateRange'
      ? this.calculateActivationMaxDate(startDate)
      : this.calculateRangeMaxDate(startDate);
  }

  onRangePickerShown(
    picker: BsDaterangepickerDirective,
    rangeKey: string,
    baseKey: string,
    useActivationDefault = false,
  ) {
    if (!picker || this.rangePickerSubs.has(picker)) {
      return;
    }

    const pickerAny = picker as any;
    const instance = pickerAny._datepickerRef?.instance;
    if (!instance?.valueChange) {
      if (!this.rangePickerPending.has(picker)) {
        this.rangePickerPending.add(picker);
        setTimeout(() => {
          this.rangePickerPending.delete(picker);
          this.onRangePickerShown(
            picker,
            rangeKey,
            baseKey,
            useActivationDefault,
          );
        }, 0);
      }
      return;
    }

    // Open calendar at current month without selecting a date
    const currentRange = (this as any)[rangeKey] as
      | (Date | undefined)[]
      | undefined;
    if (!currentRange || !currentRange[0]) {
      picker.bsValue = [];
      if (pickerAny._datepickerRef?.instance) {
        pickerAny._datepickerRef.instance.value = [];
        if (pickerAny._datepickerRef.instance._config) {
          pickerAny._datepickerRef.instance._config.value = [];
        }
      }
    }

    if (
      this.role == this.listOfRoles.ADMIN ||
      this.role == this.listOfRoles.SUPERADMIN ||
      this.role == this.listOfRoles.SUPERUSER
    ) {
      return;
    }

    const sub = instance.valueChange.subscribe(
      (range: (Date | undefined)[] | undefined) => {
        let maxDate: Date | undefined;
        let datesEnabled: Date[] | undefined;
        if (Array.isArray(range) && range[0]) {
          if (rangeKey === 'activationDateRange') {
            return;
          }
          const start = this.stripTime(range[0]);
          maxDate = this.getRangeMaxForKey(rangeKey, start);
          if (rangeKey !== 'activationDateRange') {
            datesEnabled = this.buildEnabledDates(start, maxDate);
          }
          if (this.autoPreselectRanges.has(rangeKey)) {
            this.autoPreselectRanges.delete(rangeKey);
          }
        } else {
          maxDate = useActivationDefault
            ? (this.activationDefaultMaxDate ?? undefined)
            : (this.defaultRangeMaxDate ?? undefined);
        }

        this.setRangeMaxDate(rangeKey, maxDate);
        const config = this.getRangeConfig(rangeKey, baseKey);
        this.rangeConfigs[rangeKey] = {
          ...config,
          maxDate,
          ...(datesEnabled ? { datesEnabled } : {}),
        };

        picker.maxDate = maxDate;
        if (pickerAny._datepickerRef?.instance) {
          pickerAny._datepickerRef.instance.maxDate = maxDate;
          if (datesEnabled) {
            pickerAny._datepickerRef.instance.datesEnabled = datesEnabled;
          }
          if (pickerAny._datepickerRef.instance._config) {
            pickerAny._datepickerRef.instance._config.maxDate = maxDate;
            if (datesEnabled) {
              pickerAny._datepickerRef.instance._config.datesEnabled =
                datesEnabled;
            }
          }
        }
      },
    );

    this.rangePickerSubs.set(picker, sub);
  }

  onRangePickerHidden(picker: BsDaterangepickerDirective, rangeKey?: string) {
    const sub = this.rangePickerSubs.get(picker);
    if (sub) {
      sub.unsubscribe();
      this.rangePickerSubs.delete(picker);
    }
    if (rangeKey) {
      const range = (this as any)[rangeKey] as (Date | undefined)[] | undefined;
      if (!Array.isArray(range) || range.length < 2) {
        (this as any)[rangeKey] = [];
        const pickerAny = picker as any;
        picker.bsValue = [];
        if (pickerAny._datepickerRef?.instance) {
          pickerAny._datepickerRef.instance.value = [];
          if (pickerAny._datepickerRef.instance._config) {
            pickerAny._datepickerRef.instance._config.value = [];
          }
        }
      }
    }
  }

  onActivationDateRangeChange(range: (Date | undefined)[] | undefined) {
    if (!Array.isArray(range) || range.length === 0 || !range[0]) {
      this.setRangeMaxDate(
        'activationDateRange',
        this.activationDefaultMaxDate ?? undefined,
      );
      this.resetActivationDateLimits();
      const fallbackConfig = this.getRangeConfig(
        'activationDateRange',
        'activationDatePickerConfig',
      );
      this.rangeConfigs['activationDateRange'] = {
        ...fallbackConfig,
        maxDate: this.activationDefaultMaxDate ?? undefined,
      };
      return;
    }

    if (range[1]) {
      const start = this.stripTime(range[0]);
      const end = this.stripTime(range[1]);
      const maxDate = this.getRangeMaxDate('activationDateRange', true);
      if (maxDate && end > maxDate) {
        this.activationDateRange = [start, maxDate];
      }
    }
  }

  private resetActivationDateLimits() {
    if (!this.activationDatePickerConfig) {
      return;
    }
    this.setRangeMaxDate(
      'activationDateRange',
      this.activationDefaultMaxDate ?? undefined,
    );
    this.activationDatePickerConfig = {
      ...this.activationDatePickerConfig,
      minDate: this.activationMinDate ?? undefined,
      maxDate: this.activationDefaultMaxDate ?? this.pickerVisibleMaxDate ?? undefined,
      datesDisabled: this.disabledTodayDates,
    };
  }

  private stripTime(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  private addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
}
